<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/casos" back-text="Casos">
            <template v-if="dataset.tabIndex == 1">
                <v-btn id="btnSave" color="primary" depressed @click="add" :loading="dataset.loading"
                    v-if="page.isNew && $check('Client', 'POST')">Salvar</v-btn>
                <v-btn id="btnSave" color="primary" depressed @click="update" :loading="dataset.loading"
                    v-if="!page.isNew && $check('Client', 'PATCH')">Salvar</v-btn>
            </template>

            <v-menu v-if="!page.isNew && $check('Client', 'PATCH')" offset-y left>
                <template #activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" id="btnClientActions" type="button" outlined>
                        Ações
                        <v-icon right>mdi-chevron-down</v-icon>
                    </v-btn>
                </template>
                <v-list dense class="client-actions-menu">
                    <v-list-item id="btnGenerateRvc" :disabled="rvcGenerating" @click="generateFinalReport">
                        <v-list-item-icon>
                            <v-progress-circular v-if="rvcGenerating" indeterminate size="18" width="2"></v-progress-circular>
                            <v-icon v-else>mdi-file-chart-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Gerar RVC</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item id="btnConsolidateQgc" :disabled="consolidating" @click="consolidateQgc">
                        <v-list-item-icon>
                            <v-progress-circular v-if="consolidating" indeterminate size="18" width="2"></v-progress-circular>
                            <v-icon v-else>mdi-database-sync-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Consolidar QGC</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item id="btnPreviewQgc" :disabled="qgcPreview.loading" @click="openQgcPreview">
                        <v-list-item-icon>
                            <v-progress-circular v-if="qgcPreview.loading" indeterminate size="18" width="2"></v-progress-circular>
                            <v-icon v-else>mdi-table-eye</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Prévia Edital 7</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item id="btnFinalizeObjections" :disabled="finalizing" @click="confirmFinalize">
                        <v-list-item-icon>
                            <v-progress-circular v-if="finalizing" indeterminate size="18" width="2"></v-progress-circular>
                            <v-icon v-else color="warning">mdi-check-decagram-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Finalizar Habilitações/Divergências</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- Entrega do RVC: libera (ou volta a ocultar) o resultado das analises no painel da devedora -->
                    <v-list-item id="btnRvcDelivered" :disabled="rvcDeliveredSaving" @click="toggleRvcDelivered">
                        <v-list-item-icon>
                            <v-progress-circular v-if="rvcDeliveredSaving" indeterminate size="18" width="2"></v-progress-circular>
                            <v-icon v-else :color="dataset.data.rvc_delivered_at ? 'success' : 'grey'">
                                {{ dataset.data.rvc_delivered_at ? 'mdi-eye-check-outline' : 'mdi-eye-off-outline' }}
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-if="dataset.data.rvc_delivered_at">
                                RVC entregue em {{ dataset.data.rvc_delivered_at | defaultDate('DD/MM/YYYY') }} — ocultar resultados da devedora
                            </v-list-item-title>
                            <v-list-item-title v-else>Marcar RVC como entregue (liberar resultados à devedora)</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
        </ui-page-header>

        <!-- Abas: so trocam dataset.tabIndex, como os botoes anteriores -->
        <div v-if="!page.isNew" class="ui-list-bar client-tabs-bar">
            <v-tabs :value="dataset.tabIndex - 1" show-arrows class="client-tabs">
                <v-tab @click="dataset.tabIndex = 1">
                    <v-icon left small>mdi-format-list-text</v-icon>
                    Detalhes
                </v-tab>
                <v-tab @click="dataset.tabIndex = 2">
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Documentos
                </v-tab>
                <v-tab @click="dataset.tabIndex = 3">
                    <v-icon left small>mdi-account-multiple-outline</v-icon>
                    Credores
                </v-tab>
                <v-tab @click="dataset.tabIndex = 4">
                    <v-icon left small>mdi-timeline-text-outline</v-icon>
                    Cronograma
                </v-tab>
                <v-tab @click="dataset.tabIndex = 5">
                    <v-icon left small>mdi-shape-outline</v-icon>
                    Classes
                </v-tab>
                <v-tab @click="dataset.tabIndex = 6">
                    <v-icon left small>mdi-newspaper-variant-outline</v-icon>
                    Notícias
                </v-tab>
                <v-tab v-if="!page.isNew" @click="dataset.tabIndex = 7">
                    <v-icon left small>mdi-file-chart-outline</v-icon>
                    RVC
                </v-tab>
            </v-tabs>

            <div class="d-flex flex-wrap" style="gap: 8px;">
                <v-btn v-if="$allowed('edit')" outlined @click="openNotifyDialog()">
                    <v-icon left small>mdi-bell-ring-outline</v-icon>
                    Notificar Atualização
                </v-btn>
                <v-btn v-if="!page.isNew && $check('Rma', 'GET')" outlined :to="`/fiscalizacao-mensal/casos/${$route.params.id}`">
                    <v-icon left small>mdi-calendar-check-outline</v-icon>
                    Fiscalização mensal
                </v-btn>
            </div>
        </div>

        <v-form :readonly="!$allowed('save')" v-if="dataset.tabIndex == 1" ref="form" v-model="dataForm.validForm">
            <ui-section title="Detalhes">
                <template v-if="verifyPendingEvents()" #actions>
                    <ui-action-menu small label="Relatórios" icon="mdi-file-chart-outline" :items="[
                        { text: 'Gerar RVC', icon: 'mdi-file-chart-outline', handler: generateFinalReport },
                        { divider: true },
                        { header: 'Edital' },
                        { text: 'PDF do edital', icon: 'mdi-file-document-outline', handler: generateNoticeReportPdf },
                        { text: 'Word do edital', icon: 'mdi-file-word-outline', handler: generateNoticeReportDocx },
                        { divider: true },
                        { text: 'PDF da análise de ofício', icon: 'mdi-chart-box-outline', handler: generateLetterAnalysisReportPdf },
                    ]" />
                </template>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Nome" v-model="dataset.data.name" required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Número do processo" v-model="dataset.data.process_number" required outlined hide-details="auto" :rules="[$rules.required]"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field dense label="Vara" v-model="dataset.data.local" required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-select no-data-text="Nenhuma comarca encontrada" dense :items="dataset.districts" label="Comarca" v-model="dataset.data.district_id" item-value="id" item-text="name" outlined :rules="[$rules.required]" required hide-details="auto"></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-select no-data-text="Nenhuma UF encontrada" dense :items="dataset.states" label="UF" v-model="dataset.data.state" item-value="id" item-text="name" outlined :rules="[$rules.required]" required hide-details="auto"></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field dense label="Email de acesso" v-model="dataset.data.email" required outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field dense label="Número de credores" v-model="dataset.data.total_creditors" required :rules="[$rules.required, $rules.number]" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-currency-field label="Valor total devido" dense v-model="dataset.data.total_value" :allowNegative=false hide-details="auto" outlined required :rules="[$rules.required]"></v-currency-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-select no-data-text="Nenhum colaborador encontrado" dense :items="dataset.employees" label="Especialista responsável (jurídico)" v-model="dataset.data.employee_id" item-value="id" item-text="name" outlined hide-details="auto"></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-select no-data-text="Nenhum colaborador encontrado" dense :items="dataset.employees" label="Especialista responsável (contabilidade)" v-model="dataset.data.accounting_employee_id" item-value="id" item-text="name" outlined clearable hide-details="auto"></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field dense type="date" label="Termo legal" :value="formatDate(dataset.data.legal_term)" @input="updateLegalTerm" outlined hide-details="auto"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="CNPJ" v-model="dataset.data.registration" required v-mask="this.$masks.cnpj" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select dense :items="dataset.clientTypes" label="Tipo" v-model="dataset.data.type" :rules="[$rules.required]" item-value="id" item-text="name" outlined hide-details="auto"></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-checkbox v-model="dataset.data.rural_producer" label="Caso de produtor rural" color="primary" dense hide-details class="mt-0"></v-checkbox>
                        <div class="caption ui-muted">Marque quando a recuperanda for produtor rural.</div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-switch
                            v-model="dataset.data.show_qgc_on_site"
                            label="Exibir Quadro Geral de Credores no site"
                            color="primary"
                            inset
                            hide-details="auto"
                        ></v-switch>
                        <div class="caption ui-muted">
                            Quando desabilitado, a aba e os dados públicos do QGC não ficam disponíveis nos detalhes deste caso.
                        </div>

                        <!-- Publicacao do Edital do art. 7o no site: a versao so aparece a partir desta data -->
                        <div v-if="!page.isNew && edital7.id" class="mt-4">
                            <div class="d-flex align-center" style="gap: 8px;">
                                <v-text-field v-model="edital7.date" type="date" label="Publicação do Edital do art. 7º"
                                    outlined dense hide-details="auto" clearable :disabled="edital7.saving" />
                                <v-btn outlined color="primary" small :loading="edital7.saving"
                                    :disabled="edital7.date === edital7.saved || !$check('Client', 'PATCH')" @click="saveEdital7Date">
                                    Salvar data
                                </v-btn>
                            </div>
                            <div class="caption mt-1" :class="edital7Status.color">{{ edital7Status.text }}</div>
                        </div>
                    </v-col>
                    <!-- Operacoes na Visao Credor: uma chave por operacao -->
                    <v-col cols="12" md="6">
                        <div class="font-weight-medium mb-1">Operações na Visão Credor</div>
                        <div class="caption ui-muted mb-2">
                            Cada chave libera ou bloqueia a operação feita pelo credor no site para este caso.
                        </div>
                        <v-switch v-for="flag in portalFlags" :key="flag.key" v-model="dataset.data[flag.key]" :label="flag.label"
                            color="primary" inset dense hide-details class="mt-1"></v-switch>
                    </v-col>
                </v-row>
                <v-row class="mt-2">
                    <v-col cols="12">
                        <div class="d-flex align-center justify-space-between mb-2">
                            <div class="ui-label">Empresas do Grupo</div>
                            <v-btn v-if="$allowed('create')" small outlined @click="addCompany">
                                <v-icon left small>mdi-plus</v-icon>
                                Adicionar Empresa
                            </v-btn>
                        </div>

                        <div v-if="!dataset.data.companies || dataset.data.companies.length === 0" class="caption ui-muted mb-2">
                            Nenhuma empresa adicional informada.
                        </div>

                        <!-- Regime de consolidacao do grupo: orienta QGC (um por empresa ou unico), AGC e o campo "empresa devedora" das hab/div. -->
                        <v-select v-model="dataset.data.consolidation_type" :items="consolidationTypes" item-value="id" item-text="name"
                            label="Consolidação do grupo" outlined dense hide-details="auto" class="mb-3"
                            :disabled="!dataset.data.companies || dataset.data.companies.length === 0"
                            :hint="consolidationHint" persistent-hint></v-select>

                        <v-row v-for="(company, index) in dataset.data.companies" :key="index" dense align="center">
                            <v-col cols="12" md="6">
                                <v-text-field v-model="company.name" label="Nome da empresa" outlined dense hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="5">
                                <v-text-field v-model="company.registration" label="CNPJ" outlined dense hide-details="auto" v-mask="$masks.cnpj"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="1" class="text-right">
                                <v-btn icon small @click="removeCompany(index)">
                                    <v-icon size="18" color="#dc2626">mdi-delete-outline</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field dense type="date" label="Ajuizamento" :value="formatDate(dataset.data.judgment_at)" @input="updateJudgment" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="showDefermentField">
                        <v-text-field dense type="date" label="Deferimento" :value="formatDate(dataset.data.deferment_at)" @input="updateDeferment" outlined hide-details="auto"></v-text-field>
                    </v-col>
                </v-row>
                <!-- Desativado: os prazos de hab/div ficam na Central de Creditos, aba "Cadastro da verificacao".
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field dense type="date" label="Início do prazo de hab/div" :value="formatDate(dataset.data.start_event_at)" @input="updateStartEvent" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field dense type="date" label="Prazo interno de hab/div (sistema aberto até)" :value="formatDate(dataset.data.end_event_at)" @input="updateEndEvent" outlined hide-details="auto"
                            hint="Até este dia o site recebe pedidos de habilitação e divergência." persistent-hint></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field dense type="date" label="Prazo real de hab/div (legal)" :value="formatDate(dataset.data.habdiv_legal_deadline_at)" @input="updateLegalDeadline" outlined hide-details="auto"
                            hint="Prazo do art. 7º, § 1º. Informativo; poderá ser exibido na página do caso." persistent-hint></v-text-field>
                    </v-col>
                </v-row>
                -->
                <v-alert v-if="!page.isNew" dense text type="info" class="mt-3 mb-4">
                    Os prazos de habilitação e divergência, os responsáveis pela verificação e a finalização da fase
                    ficam em <router-link :to="{ path: '/central-analise-creditos', query: { client_id: dataset.data.id } }">Créditos → Central de Créditos</router-link>, aba "Cadastro da verificação".
                </v-alert>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field dense type="date" label="Declaração da Insolvência" :value="formatDate(dataset.data.insolvency_at)" @input="updateInsolvency" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field dense type="date" label="Decretação da Quebra/Liquidação" :value="formatDate(dataset.data.liquidation_at)" @input="updateLiquidation" outlined hide-details="auto"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined counter :rules="[$rules.fileSize(15)]" hint="O arquivo não pode ser superior a 15MB" hide-details="auto" label="Banner (destaque)" :clearable="true" @change="onFileSelected('fileBanner', $event)" ref="logoFile"></v-file-input>
                        <template v-if="dataset.data.banner_url">
                            <v-img @click="openDoc(dataset.data.banner_url)" class="rounded-xl mt-2" :height="100" :width="100" :src="dataset.data.banner_url"></v-img>
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn v-if="$allowed('delete')" v-on="on" class="mt-4" type="button" outlined @click="deleteFile('banner')"><v-icon left small>mdi-delete-outline</v-icon> Excluir</v-btn>
                                </template>
                                <span>Excluir banner</span>
                            </v-tooltip>
                        </template>
                    </v-col>
                    <v-col cols="6">
                        <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined counter :rules="[$rules.fileSize(15)]" hint="O arquivo não pode ser superior a 15MB" hide-details="auto" label="Logo" :clearable="true" @change="onFileSelected('fileLogo', $event)" ref="logoFile"></v-file-input>
                        <template v-if="dataset.data.logo_url">
                            <v-img @click="openDoc(dataset.data.logo_url)" class="rounded-xl mt-2" :height="100" :width="100" :src="dataset.data.logo_url"></v-img>
                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn v-if="$allowed('delete')" v-on="on" class="mt-4" type="button" outlined @click="deleteFile('logo')"><v-icon left small>mdi-delete-outline</v-icon> Excluir</v-btn>
                                </template>
                                <span>Excluir logo</span>
                            </v-tooltip>
                        </template>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="ui-label">Descrição</div>
                        <tiptap-vuetify v-model="dataset.data.description" :extensions="extensions" hide-details="auto" />
                    </v-col>
                </v-row>
            </ui-section>

            <ui-section v-if="!page.isNew" title="Documentos Solicitados (Retorno da Devedora)" description="Pedidos feitos pela Central de Créditos. Os documentos mensais do RMA ficam em Fiscalização mensal.">
                <template #actions>
                    <v-btn v-if="(requestedDocsList.length) && $allowed('edit')" outlined color="primary" @click="openDeadlineDialog()">
                        <v-icon left small>mdi-calendar-edit</v-icon>
                        Alterar prazo
                    </v-btn>
                </template>
                <ui-empty v-if="requestedDocsList.length === 0">Nenhuma solicitação encontrada para este caso.</ui-empty>

                <v-row v-for="(request, index) in requestedDocsList" :key="index" class="mb-4">
                    <v-col cols="12">
                        <v-card outlined class="pa-4 bg-light-grey">
                            <div class="d-flex justify-space-between align-center mb-4">
                                <div>
                                    <div v-if="request.creditor_name" class="ui-small ui-muted">
                                        {{ request.creditor_name }}<span v-if="request.creditor_registration"> · {{ request.creditor_registration }}</span>
                                        <span v-if="request.target === 'creditor'"> · solicitada ao credor</span>
                                    </div>
                                    <strong>Data Limite (Prazo): {{ formatDateBr(request.deadline) }}</strong>
                                    <!-- Ciencia do atraso confirmada no pop-up (painel da devedora ou site do credor). -->
                                    <div v-if="(request.overdue_acks || []).length" class="ui-small mt-1">
                                        <v-icon x-small color="warning" class="mr-1">mdi-alert-circle-check-outline</v-icon>
                                        Ciência do atraso: {{ request.overdue_acks[0].name || request.overdue_acks[0].email }}
                                        em {{ request.overdue_acks[0].acknowledged_at | defaultDate('DD/MM/YYYY HH:mm') }}
                                        <span v-if="request.overdue_acks.length > 1" class="ui-muted">({{ request.overdue_acks.length }} confirmações)</span>
                                    </div>
                                </div>
                                <div class="d-flex align-center">
                                    <v-btn v-if="$allowed('edit')" text small color="primary" class="mr-2" @click="openDeadlineDialog(request)">
                                        <v-icon left small>mdi-calendar-edit</v-icon>
                                        Alterar prazo
                                    </v-btn>
                                    <ui-badge :text="getStatusLabel(request.status)" :color="getStatusColor(request.status)" />
                                </div>
                            </div>

                            <v-row v-for="(doc, dIndex) in request.documents" :key="dIndex" class="align-center border-bottom pb-2 mb-2">
                                <v-col cols="12" sm="6">
                                    <v-icon left small>mdi-file-document-outline</v-icon>
                                    <span>{{ doc.name }}</span>
                                    <ui-badge v-if="doc.tag" class="ml-2" :text="doc.tag" :color="doc.uploaded_after_deadline ? 'error' : (doc.file_url ? 'success' : 'warning')" />
                                </v-col>
                                <v-col cols="12" sm="6" class="text-right">
                                    <template v-if="doc.files && doc.files.length">
                                        <v-btn v-for="file in doc.files" :key="`case-file-${doc.id}-${file.id}`" :href="file.url" target="_blank" small outlined class="ml-1 mb-1" :title="file.name">
                                            {{ file.name.length > 28 ? file.name.slice(0, 25) + '...' : file.name }}
                                            <v-icon right small>mdi-open-in-new</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-btn v-else-if="doc.file_url" :href="doc.file_url" target="_blank" small outlined>
                                        Ver Arquivo
                                        <v-icon right small>mdi-open-in-new</v-icon>
                                    </v-btn>
                                    <span v-else class="ui-muted font-italic">Aguardando envio...</span>
                                </v-col>
                            </v-row>

                            <div v-if="request.justification" class="mt-6">
                                <p class="font-weight-bold text-error"><v-icon color="error" left>mdi-alert-circle-outline</v-icon> Justificativa Devedora (Prazo excedido):</p>
                                <tiptap-vuetify v-model="request.justification" :extensions="extensions" :disabled="true" hide-details="auto" class="read-only-editor" />
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </ui-section>
        </v-form>

        <template v-if="dataset.tabIndex == 2">
            <ui-section title="Documentos" description="Listar por categoria">
                <template #actions>
                    <v-btn id="btnFilter" @click="openAddDocumentModal(dataset.data)" color="primary" depressed>
                        <v-icon left small>mdi-plus</v-icon>
                        Inserir
                    </v-btn>
                </template>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-select dense :items="dataset.docCategories" no-data-text="Nenhuma categoria cadastrada" label="Categoria (aba do site)" v-model="dataset.selectedDocCategory" item-value="id" item-text="name" outlined @change="onChangeDocType()" hide-details="auto"></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field dense label="Nova categoria (cria uma aba no site)" v-model="docCategoryForm.name" outlined hide-details="auto" @keyup.enter="createDocCategory"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" class="d-flex align-center">
                        <v-btn v-if="$allowed('create')" outlined block @click="createDocCategory" :loading="docCategoryForm.loading">
                            <v-icon left small>mdi-plus</v-icon> Criar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="isSelectedDocCategoryPersisted()">
                    <v-col cols="12" class="pt-0">
                        <v-btn v-if="$allowed('delete')" small text color="error" @click="deleteDocCategory" :loading="docCategoryForm.deleting">
                            <v-icon left small>mdi-delete-outline</v-icon>
                            Remover categoria selecionada
                        </v-btn>
                    </v-col>
                </v-row>
            </ui-section>

            <ui-section :title="selectedDocCategoryName ? `Documentos de “${selectedDocCategoryName}”` : 'Documentos'" description="Ordem e subcategorias como aparecem na aba do site" flush>
                <template #actions>
                    <v-btn outlined @click="openSectionDialog()" v-if="(!editing) && $allowed('create')" :disabled="!dataset.selectedDocCategory">
                        <v-icon left small>mdi-folder-plus-outline</v-icon>
                        Nova subcategoria
                    </v-btn>
                    <v-btn outlined @click="action('edit')" v-if="!editing" :disabled="!dataList.docsFilter.length">
                        <v-icon left small>mdi-sort</v-icon>
                        Ordenar
                    </v-btn>
                    <v-btn outlined @click="action('undo')" v-if="editing">
                        <v-icon left small>mdi-close</v-icon>
                        Desfazer
                    </v-btn>
                    <v-btn color="primary" depressed @click="action('done')" v-if="(editing) && $allowed('save')">
                        <v-icon left small>mdi-check</v-icon>
                        Salvar
                    </v-btn>
                </template>

                <div v-if="editing" class="doc-groups__hint">
                    <v-icon small color="primary" class="mr-2">mdi-gesture-tap-hold</v-icon>
                    Arraste os documentos para mudar a ordem ou para movê-los de uma subcategoria para outra.
                </div>

                <template v-for="(group, gIndex) in visibleDocGroups">
                    <div :key="group.key" class="doc-group">
                        <div v-if="group.name || hasDocSections" class="doc-group__header">
                            <v-icon small class="mr-2" :color="group.name ? 'primary' : 'grey'">{{ group.name ? 'mdi-folder-outline' : 'mdi-format-vertical-align-top' }}</v-icon>
                            <span class="doc-group__title">{{ group.name || 'Topo da aba (sem subcategoria)' }}</span>
                            <span class="doc-group__count">{{ group.docs.length }} documento(s)</span>
                            <v-spacer></v-spacer>
                            <template v-if="!editing">
                                <v-btn small text color="primary" @click="openAddDocumentModal(dataset.data, group.name)">
                                    <v-icon left small>mdi-plus</v-icon> Documento
                                </v-btn>
                                <template v-if="group.name">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" icon small @click="openSectionDialog(group)"><v-icon size="18">mdi-pencil-outline</v-icon></v-btn>
                                        </template>
                                        <span>Renomear subcategoria</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" icon small @click="removeDocSection(group)"><v-icon size="18" color="#dc2626">mdi-folder-remove-outline</v-icon></v-btn>
                                        </template>
                                        <span>Remover subcategoria (os documentos vão para o topo da aba)</span>
                                    </v-tooltip>
                                </template>
                            </template>
                        </div>

                        <v-list one-line class="py-0">
                            <draggable :options="{ disabled: !editing, group: 'client-docs' }" v-model="group.docs" class="doc-group__list" :class="{ 'doc-group__list--editing': editing }">
                                <v-list-item v-for="(v, i) in group.docs" :key="v.id">
                                    <v-list-item-avatar color="grey lighten-3" size="32">
                                        <span style="user-select:none;">{{ docNumber(gIndex, i) }}</span>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="ui-cell-main" v-html="v.name"></v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="!editing">
                                        <div class="d-flex">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn v-on="on" icon small @click="deleteDocument(v)"><v-icon size="18" color="#dc2626">mdi-delete-outline</v-icon></v-btn>
                                                </template>
                                                <span>Excluir documento</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn v-on="on" icon small @click="openEditDocumentModal(v)"><v-icon size="18">mdi-pencil-outline</v-icon></v-btn>
                                                </template>
                                                <span>Editar documento</span>
                                            </v-tooltip>
                                        </div>
                                    </v-list-item-action>
                                </v-list-item>
                            </draggable>
                        </v-list>
                        <div v-if="!group.docs.length && !editing" class="doc-group__empty">
                            {{ group.name ? 'Subcategoria vazia: insira um documento ou use "Ordenar" para arrastar documentos para cá. Ela só é salva quando tiver documento.' : 'Nenhum documento nesta categoria' }}
                        </div>
                    </div>
                </template>
            </ui-section>

            <v-dialog v-model="sectionDialog.show" max-width="460px">
                <v-card class="ui-card">
                    <div class="ui-card__header">
                        <div>
                            <h3 class="ui-section-title">{{ sectionDialog.group ? 'Renomear subcategoria' : 'Nova subcategoria' }}</h3>
                            <p class="ui-section-description">Agrupa documentos dentro de “{{ selectedDocCategoryName }}”, com título próprio na aba do site.</p>
                        </div>
                    </div>
                    <div class="ui-card__body">
                        <v-text-field dense outlined autofocus label="Nome da subcategoria" v-model="sectionDialog.name" placeholder="Ex.: Recuperação judicial" hide-details="auto" maxlength="120" @keyup.enter="saveSectionDialog"></v-text-field>
                    </div>
                    <div class="ui-card__footer">
                        <v-btn outlined @click="sectionDialog.show = false" :disabled="sectionDialog.loading">Cancelar</v-btn>
                        <v-btn v-if="$allowed('save')" color="primary" depressed @click="saveSectionDialog" :loading="sectionDialog.loading" :disabled="!(sectionDialog.name || '').trim()">{{ sectionDialog.group ? 'Salvar' : 'Criar' }}</v-btn>
                    </div>
                </v-card>
            </v-dialog>

            <client-doc-details-modal ref="clientDocDetailsModalRef"></client-doc-details-modal>
        </template>

        <template v-if="dataset.tabIndex == 3">
            <ui-section title="Credores" flush>
                <v-data-table :headers="dataList.headers" :items="dataList.data" :server-items-length="dataList.count" disable-sort hide-default-footer :loading="dataList.loading" no-data-text="Nenhum caso foi encontrado" loading-text="Carregando dados..." :options.sync="dataList.options">
                    <template v-slot:[`item.name`]="{ item }">
                        <span class="ui-cell-main">{{ item.name }}</span>
                    </template>
                    <template v-slot:[`item.created_at`]="{ item }">
                        {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm") }}
                    </template>
                    <template v-slot:[`item.registration`]="{ item }">
                        {{ formatCpfCnpj(item.registration) }}
                        <v-tooltip v-if="item.registration_fictitious" bottom>
                            <template #activator="{ on }">
                                <v-icon v-on="on" small color="warning" class="ml-1">mdi-alert-circle</v-icon>
                            </template>
                            <span>CPF/CNPJ fictício: documento desconhecido na importação. Regularize antes de pagamentos.</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.amount`]="{ item }">
                        R$ {{ item.amount | currency }}
                    </template>
                    <template v-slot:[`item.type`]="{ item }">
                        {{ item.type | enum(dataset.creditorTypes, "id", "name") }}
                    </template>
                </v-data-table>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.itemsPerPage" :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </ui-section>
        </template>

        <!-- Cronograma Processual -->
        <template v-if="dataset.tabIndex == 4">
            <ui-section title="Cronograma Processual">
                <template #actions>
                    <v-btn v-if="$allowed('create')" color="primary" depressed @click="openEventDialog()">
                        <v-icon left small>mdi-plus</v-icon>
                        Adicionar evento
                    </v-btn>
                </template>

                <!-- Timeline horizontal -->
                <div class="timeline-horizontal" v-if="timeline.events.length > 0">
                    <div class="timeline-line"></div>
                    <div class="timeline-items">
                        <div v-for="(event, idx) in timeline.events" :key="event.id" class="timeline-item-h" :class="{ 'timeline-item-h--top': idx % 2 === 0, 'timeline-item-h--bottom': idx % 2 !== 0 }">
                            <div class="timeline-marker" :class="{ 'timeline-marker--done': event.date, 'timeline-marker--pending': !event.date }"></div>
                            <div class="timeline-card">
                                <div class="timeline-card-title">{{ event.title }}</div>
                                <div v-if="event.article_ref" class="timeline-card-ref">{{ event.article_ref }}</div>
                                <div class="timeline-card-date">{{ event.date ? $moment(event.date).format('DD/MM/YYYY') : 'Sem previsão' }}</div>
                                <div class="timeline-card-actions">
                                    <v-btn x-small icon @click="openEventDialog(event)"><v-icon x-small>mdi-pencil</v-icon></v-btn>
                                    <v-btn x-small icon @click="deleteEvent(event)"><v-icon x-small>mdi-delete</v-icon></v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Lista vertical (mobile-friendly + visão de gestão) -->
                <v-simple-table class="mt-6">
                    <thead>
                        <tr>
                            <th style="width: 40px">#</th>
                            <th>Evento</th>
                            <th>Referência</th>
                            <th>Data</th>
                            <th>Tipo</th>
                            <th class="text-right" style="width: 56px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="timeline.loading">
                            <td colspan="6" class="text-center py-4">
                                <v-progress-circular indeterminate size="24" width="2" color="primary"></v-progress-circular>
                            </td>
                        </tr>
                        <tr v-else-if="timeline.events.length === 0">
                            <td colspan="6" class="text-center py-4 ui-muted">Nenhum evento cadastrado</td>
                        </tr>
                        <tr v-for="(event, idx) in timeline.events" :key="event.id" v-else>
                            <td class="text-center">{{ idx + 1 }}</td>
                            <td class="ui-cell-main">{{ event.title }}</td>
                            <td>
                                <v-chip v-if="event.article_ref" x-small outlined>{{ event.article_ref }}</v-chip>
                            </td>
                            <td>
                                <span v-if="event.date">{{ $moment(event.date).format('DD/MM/YYYY') }}</span>
                                <span v-else class="ui-muted font-italic">Sem previsão</span>
                            </td>
                            <td>
                                <ui-badge :text="event.is_automatic ? 'Automático' : 'Manual'" :tone="event.is_automatic ? 'info' : 'neutral'" />
                            </td>
                            <td class="text-right">
                                <ui-row-actions :actions="[
                                    { text: 'Editar evento', icon: 'mdi-pencil-outline', handler: () => openEventDialog(event) , disabled: !$allowed('edit') },
                                    { text: 'Excluir evento', icon: 'mdi-delete-outline', handler: () => deleteEvent(event), danger: true , disabled: !$allowed('delete') },
                                ]" />
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </ui-section>
        </template>

        <!-- Classes de credores do caso -->
        <template v-if="dataset.tabIndex == 5">
            <ui-section title="Classes de Credores">
                <template v-if="!creditorClasses.form.visible" #actions>
                    <v-btn v-if="$allowed('create')" color="primary" depressed @click="openCreditorClassForm()">
                        <v-icon left small>mdi-plus</v-icon>
                        Adicionar classe
                    </v-btn>
                </template>

                <v-alert type="info" text dense class="mb-4">
                    As classes definidas aqui alimentam os campos de classe deste caso.
                    Ocultar uma classe não altera os credores já classificados nela.
                </v-alert>

                <v-form :readonly="!$allowed('save')" v-if="creditorClasses.form.visible" ref="creditorClassForm"
                    class="mb-4" @submit.prevent="saveCreditorClass()">
                    <v-row dense>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="creditorClasses.form.name" ref="creditorClassNameInput"
                                label="Nome da classe *" outlined dense autofocus
                                :disabled="creditorClasses.form.loading"
                                @keyup.enter="saveCreditorClass()"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" v-if="!creditorClasses.form.id">
                            <v-select v-model="creditorClasses.form.base_class_id"
                                :items="creditorClassBaseOptions" item-text="name" item-value="id"
                                label="Comporta-se como *" outlined dense
                                :disabled="creditorClasses.form.loading"
                                hint="Define se a classe vota e como apura o quórum"
                                persistent-hint></v-select>
                        </v-col>
                        <v-col cols="12" md="3" class="d-flex align-start">
                            <v-btn v-if="$allowed('save')" color="primary" depressed class="mr-2"
                                :loading="creditorClasses.form.loading" @click="saveCreditorClass()">
                                Salvar
                            </v-btn>
                            <v-btn text :disabled="creditorClasses.form.loading"
                                @click="closeCreditorClassForm()">
                                Cancelar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>

                <v-simple-table dense v-if="creditorClasses.data.length">
                    <template #default>
                        <thead>
                            <tr>
                                <th>Classe</th>
                                <th>Origem</th>
                                <th class="text-center">Situação</th>
                                <th class="text-right" style="width: 56px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in creditorClasses.data" :key="item.id"
                                :class="{ 'ui-muted': !item.is_active }">
                                <td :class="{ 'ui-cell-main': item.is_active }">{{ item.name }}</td>
                                <td class="text-caption">
                                    {{ item.is_predefined ? 'Pré-definida' : getCreditorClassBaseName(item) }}
                                </td>
                                <td class="text-center">
                                    <ui-badge :text="item.is_active ? 'Visível' : 'Oculta'" :color="item.is_active ? 'success' : 'grey'" />
                                </td>
                                <td class="text-right">
                                    <ui-row-actions :actions="[
                                        { text: 'Editar classe', icon: 'mdi-pencil-outline', handler: () => openCreditorClassForm(item), hidden: !(!item.is_predefined && item.is_active) , disabled: !$allowed('edit') },
                                        { text: 'Ocultar classe', icon: 'mdi-delete-outline', handler: () => confirmCreditorClassDeactivation(item), hidden: !item.is_active, danger: true },
                                        { text: 'Reativar classe', icon: 'mdi-restore', handler: () => activateCreditorClass(item), hidden: item.is_active },
                                    ]" />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <ui-empty v-else-if="!creditorClasses.loading">Nenhuma classe cadastrada para este caso.</ui-empty>
            </ui-section>
        </template>

        <!-- Confirmação de ocultação de classe -->
        <v-dialog v-model="creditorClasses.deactivation.dialog" max-width="480px" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Ocultar classe</h3>
                </div>
                <div class="ui-card__body">
                    <p class="mb-2">
                        A classe <strong>{{ creditorClasses.deactivation.item.name }}</strong>
                        deixará de aparecer nos campos de seleção deste caso.
                    </p>
                    <v-alert v-if="creditorClasses.deactivation.creditorsCount > 0" type="warning" text dense>
                        <strong>{{ creditorClasses.deactivation.creditorsCount }}</strong>
                        {{ creditorClasses.deactivation.creditorsCount === 1 ? 'credor está classificado' : 'credores estão classificados' }}
                        nesta classe. Eles continuam no QGC, no quórum e nos relatórios.
                    </v-alert>
                    <v-alert v-else type="info" text dense>
                        Nenhum credor está classificado nesta classe.
                    </v-alert>
                </div>
                <div class="ui-card__footer">
                    <v-btn text :disabled="creditorClasses.deactivation.loading"
                        @click="creditorClasses.deactivation.dialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="error" depressed :loading="creditorClasses.deactivation.loading"
                        @click="deactivateCreditorClass()">
                        Ocultar
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <!-- Dialog para adicionar/editar evento -->
        <!-- Noticias do caso: aparecem na aba "Noticias" da pagina publica do caso -->
        <!-- Introducao e topicos preliminares do RVC: impressos logo apos a capa. -->
        <template v-if="dataset.tabIndex == 7">
            <ui-section title="Introdução e tópicos preliminares do RVC" description="Impressos logo após a capa do Relatório de Verificação de Créditos. Em branco, o relatório sai sem essas páginas.">
                <template #actions>
                    <v-btn v-if="$allowed('save')" outlined color="primary" :loading="rvcTexts.suggesting" :disabled="rvcTexts.saving" @click="suggestRvcTexts">
                        <v-icon left small>mdi-auto-fix</v-icon>
                        Preencher automaticamente
                    </v-btn>
                    <v-btn v-if="$allowed('save')" color="primary" depressed class="ml-2" :loading="rvcTexts.saving" :disabled="rvcTexts.suggesting" @click="saveRvcTexts">
                        <v-icon left small>mdi-content-save-outline</v-icon>
                        Salvar textos
                    </v-btn>
                </template>
                <v-alert dense text type="info" class="mb-4">
                    O preenchimento automático monta os textos com os dados do caso (ajuizamento, deferimento, comarca e vara, edital do art. 52,
                    prazo e quantidade de habilitações e divergências) e substitui o que está abaixo. O que faltar no cadastro aparece entre colchetes.
                </v-alert>
                <div class="text-subtitle-2 mb-2">Introdução</div>
                <ui-document-editor v-model="rvcTexts.introduction" orientation="landscape" :disabled="!$allowed('save') || rvcTexts.saving"
                    :min-height="220" :max-height="520" title="Introdução do RVC" placeholder="Introdução do RVC" class="mb-6" />
                <div class="text-subtitle-2 mb-2">Tópicos preliminares</div>
                <ui-document-editor v-model="rvcTexts.preliminary_topics" orientation="landscape" :disabled="!$allowed('save') || rvcTexts.saving"
                    :min-height="220" :max-height="520" title="Tópicos preliminares do RVC" placeholder="Tópicos preliminares do RVC" />
            </ui-section>
        </template>

        <template v-if="dataset.tabIndex == 6">
            <ui-section title="Notícias" description="Publicadas na aba Notícias da página do caso no site">
                <template #actions>
                    <v-btn v-if="$allowed('create')" color="primary" depressed @click="openNewsDialog()">
                        <v-icon left small>mdi-plus</v-icon>
                        Adicionar notícia
                    </v-btn>
                </template>
                <v-simple-table>
                    <thead>
                        <tr>
                            <th style="width: 110px">Data</th>
                            <th>Título</th>
                            <th style="width: 90px">Imagem</th>
                            <th>Cadastrada por</th>
                            <th class="text-right" style="width: 56px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="news.loading">
                            <td colspan="5" class="text-center py-4">
                                <v-progress-circular indeterminate size="24" width="2" color="primary"></v-progress-circular>
                            </td>
                        </tr>
                        <tr v-else-if="news.items.length === 0">
                            <td colspan="5" class="text-center py-4 ui-muted">Nenhuma notícia cadastrada</td>
                        </tr>
                        <tr v-for="item in news.items" :key="item.id" v-else>
                            <td>{{ $moment(item.published_at).format('DD/MM/YYYY') }}</td>
                            <td class="ui-cell-main">{{ item.title }}</td>
                            <td>
                                <a v-if="item.image_url" :href="item.image_url" target="_blank" rel="noopener">
                                    <v-img :src="item.image_url" width="64" height="40" class="rounded" cover></v-img>
                                </a>
                                <span v-else class="ui-muted">—</span>
                            </td>
                            <td>{{ item.admin_name || '—' }}</td>
                            <td class="text-right">
                                <ui-row-actions :actions="[
                                    { text: 'Editar notícia', icon: 'mdi-pencil-outline', handler: () => openNewsDialog(item) , disabled: !$allowed('edit') },
                                    { text: 'Excluir notícia', icon: 'mdi-delete-outline', handler: () => deleteNews(item), danger: true , disabled: !$allowed('delete') },
                                ]" />
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </ui-section>
        </template>

        <v-dialog v-model="news.dialog" max-width="860px" persistent scrollable>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">{{ news.editing ? 'Editar notícia' : 'Nova notícia' }}</h3>
                    <v-btn icon small @click="news.dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <div class="ui-card__body">
                    <v-row dense>
                        <v-col cols="12" md="8">
                            <v-text-field v-model="news.form.title" label="Título *" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="news.form.published_at" label="Data *" type="date" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="news.imageFile" label="Imagem (opcional)" accept="image/*" outlined dense
                                prepend-icon="" append-icon="mdi-image-outline" hint="JPG ou PNG, até 10 MB" persistent-hint hide-details="auto"></v-file-input>
                            <div v-if="news.editing && news.editing.image_url && !news.imageFile && !news.removeImage" class="d-flex align-center mt-2" style="gap: 12px;">
                                <v-img :src="news.editing.image_url" max-width="160" max-height="100" class="rounded" contain></v-img>
                                <v-btn v-if="$allowed('delete')" x-small text color="error" @click="news.removeImage = true">Remover imagem atual</v-btn>
                            </div>
                            <div v-else-if="news.removeImage" class="text-caption ui-muted mt-2">A imagem atual será removida ao salvar.</div>
                        </v-col>
                        <v-col cols="12">
                            <p class="font-weight-bold mb-1">Texto</p>
                            <tiptap-vuetify v-model="news.form.content" :extensions="extensions" placeholder="Escreva a notícia..." />
                        </v-col>
                    </v-row>
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="news.dialog = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('save')" color="primary" depressed @click="saveNews()" :loading="news.saving">
                        {{ news.editing ? 'Salvar' : 'Publicar' }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="timeline.dialog" max-width="500px" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">{{ timeline.editing ? 'Editar Evento' : 'Novo Evento' }}</h3>
                    <v-btn icon small @click="timeline.dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <div class="ui-card__body">
                    <v-text-field v-model="timeline.form.title" label="Título do evento *" outlined dense></v-text-field>
                    <v-text-field v-model="timeline.form.article_ref" label="Referência legal (ex: art. 51)" outlined dense></v-text-field>
                    <v-text-field v-model="timeline.form.date" label="Data" type="date" outlined dense hint="Deixe vazio para 'Sem previsão'" persistent-hint></v-text-field>
                    <v-textarea v-model="timeline.form.description" label="Descrição (opcional)" outlined dense rows="3"></v-textarea>
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="timeline.dialog = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('save')" color="primary" depressed @click="saveEvent()" :loading="timeline.saving">
                        {{ timeline.editing ? 'Salvar' : 'Adicionar' }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogViewDoc" max-width="60%">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogNotify" max-width="900px" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Notificar Credores</h3>
                    <v-btn icon small @click="dialogNotify = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <div class="ui-card__body">
                    <v-alert type="info" text dense class="mb-4">
                        A seleção considera a data de inclusão do crédito no QGC e elimina duplicidades por
                        CPF/CNPJ e e-mail.
                    </v-alert>

                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="notifyIncludedFrom" type="datetime-local" outlined dense
                                label="Credores incluídos a partir de" clearable
                                hint="Deixe vazio para considerar todas as datas" persistent-hint
                                @change="loadNotificationPreview" />
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex align-center">
                            <v-checkbox v-model="notifyExcludePrevious"
                                label="Não reenviar para credores já notificados" hide-details
                                @change="loadNotificationPreview" />
                        </v-col>
                    </v-row>

                    <v-alert v-if="!notifyExcludePrevious" type="warning" outlined dense>
                        Credores que já receberam notificações anteriores deste caso poderão receber novamente.
                    </v-alert>

                    <div class="d-flex align-center mb-3">
                        <strong>Prévia dos destinatários</strong>
                        <v-spacer />
                        <v-btn small outlined :loading="notifyPreviewLoading"
                            @click="loadNotificationPreview">
                            <v-icon left small>mdi-refresh</v-icon> Atualizar prévia
                        </v-btn>
                    </div>

                    <div v-if="notifyPreviewLoading" class="text-center py-4">
                        <v-progress-circular indeterminate color="primary" />
                    </div>
                    <template v-else-if="notifyPreview">
                        <v-row dense class="mb-2">
                            <v-col cols="6" md="2"><div class="ui-label">Elegíveis</div>{{ notifyPreview.eligible || 0 }}</v-col>
                            <v-col cols="6" md="2"><div class="ui-label">Já notificados</div>{{ notifyPreview.previously_notified || 0 }}</v-col>
                            <v-col cols="6" md="2"><div class="ui-label">Duplicados</div>{{ notifyPreview.duplicates || 0 }}</v-col>
                            <v-col cols="6" md="3"><div class="ui-label">Sem e-mail</div>{{ notifyPreview.without_email || 0 }}</v-col>
                            <v-col cols="6" md="3"><div class="ui-label">E-mail inválido</div>{{ notifyPreview.invalid_email || 0 }}</v-col>
                        </v-row>
                        <div v-if="notifyPreview.last_notification_at" class="text-caption ui-muted mb-3">
                            Última campanha enviada em {{ notifyPreview.last_notification_at | defaultDate("DD/MM/YYYY HH:mm") }}.
                        </div>
                        <v-alert v-if="!notifyPreview.eligible" type="warning" outlined dense>
                            Nenhum credor está elegível com os filtros atuais.
                        </v-alert>
                    </template>

                    <p class="font-weight-bold mb-1">Mensagem do E-mail</p>
                    <tiptap-vuetify v-model="notifyText" :extensions="extensions" placeholder="Escreva a mensagem aqui..." />
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="dialogNotify = false" :disabled="notifyLoading">Cancelar</v-btn>
                    <v-btn v-if="$allowed('client.notify')" color="primary" depressed @click="sendNotification()" :loading="notifyLoading"
                        :disabled="notifyPreviewLoading || !notifyPreview || !notifyPreview.eligible">
                        <v-icon left small>mdi-send</v-icon> Confirmar e Enviar
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>

        <document-request-deadline-dialog v-model="deadlineDialog.open" :client-id="$route.params.id" :request="deadlineDialog.request"
            :requests="requestedDocsList" @saved="loadRequestedDocs" />

        <v-dialog v-model="consolidateDialog" max-width="500px">
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Consolidar QGC</h3>
                </div>
                <div class="ui-card__body">
                    Deseja replicar todos os créditos do Artigo 7 para o QGC Consolidado? Esta ação substituirá a versão atual do consolidado.
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="consolidateDialog = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('client.qgc')" color="primary" depressed @click="doConsolidateQgc">Confirmar</v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="finalizeDialog" max-width="500px">
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Finalizar Impugnações</h3>
                </div>
                <div class="ui-card__body">
                    Deseja realmente finalizar a etapa de impugnações para este caso? Após finalizar, o sistema irá gerar uma nova
                    versão dos créditos com base nas impugnações aprovadas.
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="finalizeDialog = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('edit')" color="primary" depressed @click="finalizeObjections">Confirmar</v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="generateDialog" max-width="500px">
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">Gerar Versão</h3>
                </div>
                <div class="ui-card__body">
                    Deseja executar a geração da versão dos créditos agora?
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="generateDialog = false; load();">Não</v-btn>
                    <v-btn v-if="$allowed('client.qgc')" color="primary" depressed @click="doGenerateVersion">Sim, gerar agora</v-btn>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="qgcPreview.dialog" max-width="1200px" scrollable>
            <v-card>
                <v-card-title class="qgc-preview-title">
                    <div>
                        <div class="text-h6 font-weight-bold">Prévia do QGC - Edital 7</div>
                        <div class="text-caption grey--text text--darken-1">
                            Confira os créditos antes de gerar a versão definitiva.
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="qgcPreview.dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-5">
                    <v-row class="mb-4">
                        <v-col cols="12" md="4" lg="2">
                            <div class="qgc-preview-summary">
                                <span>Total previsto</span>
                                <strong>{{ qgcPreview.summary.total || 0 }}</strong>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <div class="qgc-preview-summary">
                                <span>Créditos do Edital 52</span>
                                <strong>{{ qgcPreview.summary.from_source_claims || 0 }}</strong>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <div class="qgc-preview-summary user-event">
                                <span>Hab/Div</span>
                                <strong>{{ qgcPreview.summary.from_user_events || 0 }}</strong>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                            <div class="qgc-preview-summary official-letter">
                                <span>Análise de Ofício</span>
                                <strong>{{ qgcPreview.summary.from_official_letters || 0 }}</strong>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                            <div class="qgc-preview-summary attorney">
                                <span>Honorários</span>
                                <strong>{{ qgcPreview.summary.from_attorney_fees || 0 }}</strong>
                            </div>
                        </v-col>
                    </v-row>

                    <v-data-table
                        :headers="qgcPreview.headers"
                        :items="qgcPreview.rows"
                        :loading="qgcPreview.loading"
                        :items-per-page="15"
                        class="app-table qgc-preview-table"
                        no-data-text="Nenhum crédito previsto"
                        loading-text="Carregando prévia..."
                    >
                        <template v-slot:[`item.registration`]="{ item }">
                            {{ formatCpfCnpj(item.registration) }}
                            <v-tooltip v-if="item.registration_fictitious" bottom>
                                <template #activator="{ on }">
                                    <v-icon v-on="on" small color="warning" class="ml-1">mdi-alert-circle</v-icon>
                                </template>
                                <span>CPF/CNPJ fictício: documento desconhecido na importação. Regularize antes de pagamentos.</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:[`item.type`]="{ item }">
                            <v-chip small label outlined color="primary">
                                {{ getTypeName(item.type) }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.amount`]="{ item }">
                            R$ {{ item.amount | currency }}
                        </template>

                        <template v-slot:[`item.source_description`]="{ item }">
                            <div class="qgc-preview-source">
                                <v-chip small label :color="getSourceColor(item.source_type)" :outlined="item.source_type !== 'attorney_fee'">
                                    {{ item.source_label || getSourceLabel(item.source_type) }}
                                </v-chip>
                                <span>{{ item.source_description }}</span>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="qgcPreview.dialog = false">Fechar</v-btn>
                    <v-btn v-if="$allowed('client.qgc')" color="primary" elevation="0" :loading="qgcPreview.generating" @click="doGenerateVersionFromPreview">
                        Gerar Edital 7
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"
import object from "@/common/util/object"

import ClientDocDetailsModal from "@/components/ClientDocDetailsModal.vue"
import DocumentRequestDeadlineDialog from "@/components/DocumentRequestDeadlineDialog.vue"

import clientTypes from "@/common/data/client-types.data"
import consolidationTypes from "@/common/data/consolidation-types.data"
import creditorTypes from "@/common/data/creditor-types.data"
import creditorClassUtil from "@/common/util/creditor-class.util"
import clientDocTypes from "@/common/data/client-doc-types.data"

import moment, { APP_TIMEZONE } from "@/common/util/date-time"
import { cpf, cnpj } from 'cpf-cnpj-validator'
import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph
} from 'tiptap-vuetify'

import { eventHub } from "@/main";
import draggable from 'vuedraggable';

export default {
    name: "ClientDetails",

    components: {
        'tiptap-vuetify': TiptapVuetify,
        'client-doc-details-modal': ClientDocDetailsModal,
        DocumentRequestDeadlineDialog,
        draggable,
    },

    data: () => ({
        // Versao do Edital do art. 7o do QGC do caso: a data libera a lista no site.
        edital7: { id: null, date: null, saved: null, saving: false },
        consolidationTypes,
        // Introducao e topicos preliminares do RVC (aba "RVC"); gravados a parte do formulario.
        rvcTexts: { introduction: '', preliminary_topics: '', saving: false, suggesting: false },
        consolidating: false,
        finalizing: false,
        rvcGenerating: false,
        consolidateDialog: false,
        finalizeDialog: false,
        generateDialog: false,
        rvcDeliveredSaving: false,
        qgcPreview: {
            dialog: false,
            loading: false,
            generating: false,
            summary: {},
            rows: [],
            headers: [
                { text: "Nome", value: "name" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Classe", value: "type" },
                { text: "Valor", value: "amount" },
                { text: "Origem", value: "source_description" },
            ],
        },

	        requestedDocsList: [],
        deadlineDialog: { open: false, request: null },

        page: {
            isNew: false,
            title: "",
        },
        items: [
            { id: null, client_id: null, order: null }
        ],
        editing: false,
        before: null,
        dataset: {
            clientTypes: clientTypes,
            creditorTypes: creditorTypes,
            clientDocTypes: clientDocTypes,
            docCategories: [],
            breadcrumbItems: [],
            states: states,
            data: {
                judgment_at: null,
                deferment_at: null,
                insolvency_at: null,
                liquidation_at: null,
                end_event_at: null,
                start_event_at: null,
                habdiv_legal_deadline_at: null,
                legal_term: null,
                show_qgc_on_site: false,
                rural_producer: false,
                consolidation_type: null,
                creditor_portal_enabled: true,
                portal_habdiv_enabled: true,
                portal_procurators_enabled: true,
                portal_accreditations_enabled: true,
                portal_bank_enabled: true,
                companies: []
            },
            districts: [],
            employees: [],
            menuLegalTerm: false,
            menuJudgment: false,
            menuDeferment: false,
            menuStartEvent: false,
            menuEndEvent: false,
            selectedDocType: null,
            selectedDocCategory: null,
            tabIndex: 1,
            loading: false
        },
        selectedDoc: null,
        dialogViewDoc: false,
        dialogDocDetails: false,
        dialogNotify: false,
        notifyLoading: false,
        notifyText: '',
        notifyIncludedFrom: '',
        notifyExcludePrevious: true,
        notifyPreviewLoading: false,
        notifyPreview: null,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
        docCategoryForm: {
            name: '',
            loading: false,
            deleting: false,
        },
        // Documentos da categoria selecionada agrupados por subcategoria (null = topo da aba).
        docGroups: [],
        sectionDialog: { show: false, name: '', group: null, loading: false },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Paragraph,
        ],

        news: {
            items: [],
            loading: false,
            saving: false,
            dialog: false,
            editing: null,
            imageFile: null,
            removeImage: false,
            form: { title: '', published_at: '', content: '' },
        },
        timeline: {
            events: [],
            loading: false,
            saving: false,
            dialog: false,
            editing: null,
            form: {
                title: '',
                article_ref: '',
                date: '',
                description: '',
            },
        },
        creditorClasses: {
            data: [],
            loading: false,
            form: {
                visible: false,
                loading: false,
                id: null,
                name: '',
                base_class_id: null,
            },
            deactivation: {
                dialog: false,
                loading: false,
                item: {},
                creditorsCount: 0,
            },
        },

        dataList: {
            filter: {
                name: "",
                status: "",
                type: "",
                district: ""
            },
            docsFilter: [],

            headers: [
                { text: "Nome", value: "name" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Valor", value: "amount" },
                { text: "Classe", value: "type" },
                { text: "Criado em", value: "created_at" },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
            }
        },
    }),

    created() {
        this.loadData()
        this.loadEdital7()

        eventHub.$on('DIALOG-CLIENT-DOC-DETAILS', value => {
            this.dialogDocDetails = value;
        });
    },

    watch: {
        'dataset.tabIndex'(val) {
            if (val === 4) this.loadTimeline();
            if (val === 5) this.loadCreditorClasses();
            if (val === 6) this.loadNews();
        },

        'dataset.data.type'(value, oldValue) {
            if (oldValue === undefined || Number(value) === Number(oldValue)) return;

            // Ao mudar para falencia, descarta o deferimento ja preenchido:
            // apenas esconder o campo manteria o valor antigo sendo gravado.
            if (Number(value) === 2) this.dataset.data.deferment_at = null;
        },
    },

    computed: {
        consolidationHint() {
            if (!this.dataset.data.companies || this.dataset.data.companies.length === 0) return 'Disponível quando houver empresas do grupo.';
            const option = this.consolidationTypes.find((item) => item.id === (this.dataset.data.consolidation_type || null));
            return option ? option.hint : '';
        },
        // Mesma regra do site (ClientQgcVersionService.publicVersions): a versao
        // aparece a partir da data salva, pelo dia de Brasilia.
        edital7Status() {
            const saved = this.edital7.saved;
            if (this.edital7.date !== saved) return { text: 'Data alterada: clique em "Salvar data".', color: 'warning--text' };
            if (!saved) return { text: 'Sem data: o Edital do art. 7º não aparece no site.', color: 'error--text' };
            const label = saved.split('-').reverse().join('/');
            const today = moment().tz(APP_TIMEZONE).format('YYYY-MM-DD');
            if (saved <= today) return { text: `Publicado em ${label}: visível no site.`, color: 'success--text' };
            return { text: `Aparece no site a partir de ${label}.`, color: 'ui-muted' };
        },

        // Chaves das operacoes na Visao Credor (uma por operacao).
        portalFlags() {
            return [
                { key: 'portal_habdiv_enabled', label: 'Pedidos de Hab/Div' },
                { key: 'portal_procurators_enabled', label: 'Vínculos de procuradores' },
                { key: 'portal_accreditations_enabled', label: 'Credenciamentos' },
                { key: 'portal_bank_enabled', label: 'Envio de dados bancários' },
            ];
        },
        options() {
            return {
                disabled: !this.editing
            }
        },
        selectedDocCategoryName() {
            const category = this.dataset.docCategories.find((item) => item.id === this.dataset.selectedDocCategory);
            return category ? category.name : '';
        },
        hasDocSections() {
            return this.docGroups.some((group) => group.name);
        },
        // O grupo do topo so aparece quando tem documento, quando nao ha subcategorias
        // ou durante a ordenacao (para poder arrastar documentos de volta para ele).
        visibleDocGroups() {
            return this.docGroups.filter((group) => group.name || group.docs.length || this.editing || !this.hasDocSections);
        },
        // Falencia nao tem deferimento: o marco equivalente e a decretacao da
        // quebra, que tem campo proprio.
        showDefermentField() {
            return Number(this.dataset.data.type) !== 2;
        },
        creditorClassBaseOptions() {
            // Extraconcursais fica de fora: herdar dela criaria uma classe que
            // nao participa da votacao.
            return this.dataset.creditorTypes.filter((item) => Number(item.id) !== 5);
        },
    },

    methods: {
        getTypeName(typeId) {
            const type = this.dataset.creditorTypes.find(item => Number(item.id) === Number(typeId));
            return type && type.name ? type.name : 'N/A';
        },

        getSourceLabel(sourceType) {
            const labels = {
                import: "Importação",
                edital_52: "Edital 52",
                edital_7: "Edital 7",
                user_event: "Hab/Div",
                user_event_exclusion: "Exclusão (Hab/Div)",
                chc: "CHC",
                official_letter: "Análise de Ofício",
                official_letter_exclusion: "Exclusão (Ofício)",
                attorney_fee: "Honorário",
                judicial_challenge: "Impugnação",
                judicial_challenge_sentence: "Impugnação com sentença",
                manual: "Manual",
            };

            return labels[sourceType] || "Manual";
        },

        getSourceColor(sourceType) {
            const colors = {
                attorney_fee: "warning",
                user_event: "success",
                user_event_exclusion: "error",
                chc: "teal",
                official_letter: "deep-purple",
                official_letter_exclusion: "error",
                edital_52: "info",
                edital_7: "primary",
                import: "grey",
                judicial_challenge: "purple",
                judicial_challenge_sentence: "purple",
            };

            return colors[sourceType] || "grey";
        },

        confirmFinalize() {
            this.finalizeDialog = true;
        },

        consolidateQgc() {
            if (!this.dataset.data.id) return;
            this.consolidateDialog = true;
        },

        async doConsolidateQgc() {
            this.consolidateDialog = false;
            try {
                this.consolidating = true;
                const { data } = await axios.post(`api/admin/clients/${this.dataset.data.id}/consolidate-qgc`);
                const consolidated = data.content ? data.content.consolidated : 0;
                this.$dialog.notify.success(`QGC consolidado. ${consolidated} créditos replicados.`, { position: "top-right", timeout: 3000 });
            } catch (err) {
                console.error('Erro ao consolidar QGC', err);
                this.$dialog.notify.error('Erro ao consolidar QGC', { position: 'top-right', timeout: 3000 });
            } finally {
                this.consolidating = false;
            }
        },

        async openQgcPreview() {
            if (!this.dataset.data.id) return;

            this.qgcPreview.dialog = true;
            this.qgcPreview.loading = true;

            try {
                const { data } = await axios.get(`api/admin/clients/${this.dataset.data.id}/generate-claim-version-preview`);
                const content = data.content || {};
                this.qgcPreview.summary = content;
                this.qgcPreview.rows = content.rows || [];
            } catch (err) {
                console.error('Erro ao carregar prévia do QGC', err);
                this.qgcPreview.dialog = false;
                this.$dialog.notify.error(this.$codes(err) || 'Erro ao carregar prévia do QGC', { position: 'top-right', timeout: 3000 });
            } finally {
                this.qgcPreview.loading = false;
            }
        },

        async doGenerateVersionFromPreview() {
            this.qgcPreview.generating = true;

            try {
                const { data } = await axios.post(`api/admin/clients/${this.dataset.data.id}/generate-claim-version`);
                const generated = data.content ? data.content.generated : 0;
                this.qgcPreview.dialog = false;
                this.$dialog.notify.success(`Edital 7 gerado com ${generated} crédito(s).`, { position: "top-right", timeout: 3000 });
                await this.load();
            } catch (err) {
                console.error('Erro ao gerar versão', err);
                this.$dialog.notify.error(this.$codes(err) || 'Erro ao gerar versão', { position: 'top-right', timeout: 3000 });
            } finally {
                this.qgcPreview.generating = false;
            }
        },

        // Antes da entrega do RVC o painel da devedora mostra todos os pedidos como "em analise".
        async toggleRvcDelivered() {
            if (!this.dataset.data.id) return;
            const delivered = !!this.dataset.data.rvc_delivered_at;
            const proceed = await this.$dialog.confirm({
                title: delivered ? 'Ocultar resultados da devedora' : 'Marcar RVC como entregue',
                text: delivered
                    ? 'O painel da devedora voltará a mostrar os pedidos como "em análise", sem aprovado/rejeitado. Confirmar?'
                    : 'A partir de agora o painel da devedora passa a exibir o resultado das análises (aprovado, rejeitado, parcial) de todos os pedidos deste caso. Confirmar a entrega do RVC?',
                actions: { false: 'Cancelar', true: 'Confirmar' },
            });
            if (!proceed) return;
            try {
                this.rvcDeliveredSaving = true;
                const rvc_delivered_at = delivered ? null : (new Date()).toISOString().slice(0, 19).replace('T', ' ');
                await axios.patch(`api/admin/clients/${this.dataset.data.id}`, { rvc_delivered_at });
                this.dataset.data.rvc_delivered_at = rvc_delivered_at;
                this.$dialog.notify.success(delivered ? 'Resultados ocultados no painel da devedora.' : 'RVC marcado como entregue: resultados liberados à devedora.', { position: 'top-right', timeout: 3000 });
            } catch (err) {
                console.error('Erro ao atualizar entrega do RVC', err);
                this.$dialog.notify.error(this.$codes(err) || 'Erro ao atualizar entrega do RVC', { position: 'top-right', timeout: 3000 });
            } finally {
                this.rvcDeliveredSaving = false;
            }
        },

        async finalizeObjections() {
            this.finalizeDialog = false;
            if (!this.dataset.data.id) return;
            try {
                this.finalizing = true;
                await axios.patch(`api/admin/clients/${this.dataset.data.id}`, { objections_finalized_at: (new Date()).toISOString().slice(0, 19).replace('T', ' ') });
                this.$dialog.notify.success('Etapa de impugnações finalizada.', { position: "top-right", timeout: 3000 });
                this.generateDialog = true;
            } catch (err) {
                console.error('Erro ao finalizar impugnações', err);
                this.$dialog.notify.error('Erro ao finalizar impugnações', { position: 'top-right', timeout: 3000 });
            } finally {
                this.finalizing = false;
            }
        },

        async doGenerateVersion() {
            this.generateDialog = false;
            try {
                await axios.post(`api/admin/clients/${this.dataset.data.id}/generate-claim-version`);
                this.$dialog.notify.success('Geração iniciada.', { position: "top-right", timeout: 3000 });
            } catch (err) {
                console.error('Erro ao gerar versão', err);
                this.$dialog.notify.error('Erro ao gerar versão', { position: 'top-right', timeout: 3000 });
            }
            this.load();
        },
        
        // Pelo botao da secao abre o lote; pelo botao do card, so aquela solicitacao.
        openDeadlineDialog(request = null) {
            this.deadlineDialog = { open: true, request };
        },

        async loadRequestedDocs() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/clients/${this.$route.params.id}/document-requests`);
                this.requestedDocsList = result.data.content || result.data;
            } catch (error) {
                console.log('Erro ao carregar documentos solicitados: ', error);
            }
        },

        openNotifyDialog() {
            const companyName = this.dataset.data.name || 'Nome da Empresa';
            const caseType = this.dataset.data.type;
            const baseUrl = 'https://brizolaejapur.com.br';

            const typeRoutes = {
                1: '/casos/recuperacoes',
                2: '/casos/falencias',
                3: '/casos/liquidacao-judicial',
                4: '/casos/insolvencia-civil',
            };

            const caseLink = `${baseUrl}${typeRoutes[caseType] || '/casos/recuperacoes'}`;

            this.notifyText = `
                <p>Informamos que houve um novo andamento processual relevante, com novo documento disponibilizado para o caso <strong>${companyName}</strong>.</p>
                <p>Você pode consultar pelo link: <a href="${caseLink}" target="_blank">${caseLink}</a></p>
            `;

            this.notifyIncludedFrom = '';
            this.notifyExcludePrevious = true;
            this.notifyPreview = null;
            this.dialogNotify = true;
            this.loadNotificationPreview();
        },

        async loadNotificationPreview() {
            if (!this.$route.params.id) return;

            this.notifyPreviewLoading = true;
            try {
                const result = await axios.get(`/api/admin/clients/${this.$route.params.id}/notification-preview`, {
                    params: {
                        included_from: this.notifyIncludedFrom || undefined,
                        exclude_previously_notified: this.notifyExcludePrevious
                    }
                });
                this.notifyPreview = result.data.content;
            } catch (error) {
                this.notifyPreview = null;
                this.$dialog.notify.error(this.$codes(error) || "Erro ao carregar a prévia de destinatários.", {
                    position: 'top-right',
                    timeout: 3000
                });
            } finally {
                this.notifyPreviewLoading = false;
            }
        },

        async sendNotification() {
            if (!this.notifyText || this.notifyText.trim() === '') {
                this.$dialog.notify.error("A mensagem não pode estar vazia.", { position: 'top-right', timeout: 2000 });
                return;
            }

            if (!this.notifyPreview || !this.notifyPreview.eligible) {
                this.$dialog.notify.warning("Nenhum credor está elegível com os filtros atuais.", { position: 'top-right', timeout: 2500 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Tem certeza que deseja enviar este e-mail para ${this.notifyPreview.eligible} credor(es) elegível(is)?`,
                title: 'Confirmar Envio',
                actions: { false: 'Cancelar', true: 'Sim, Enviar' }
            });

            if (!proceedAction) return;

            this.notifyLoading = true;

            try {
                const result = await axios.post(`/api/admin/clients/${this.$route.params.id}/notify`, {
                    message: this.notifyText,
                    included_from: this.notifyIncludedFrom || null,
                    exclude_previously_notified: this.notifyExcludePrevious
                });
                const summary = result.data.content || {};
                const reason = Array.isArray(summary.errors) && summary.errors.length ? ` Motivo: ${summary.errors.join(" | ")}` : "";

                // Nenhum e-mail saiu: mantem o dialogo aberto (com o texto) e mostra o motivo.
                if (summary.failed && !summary.sent) {
                    this.$dialog.notify.error(`Nenhuma notificação foi enviada (${summary.failed} falha(s)).${reason}`, { position: "top-right", timeout: 10000 });
                    return;
                }

                if (summary.failed) {
                    this.$dialog.notify.warning(`Envio concluído: ${summary.sent} enviado(s) e ${summary.failed} falha(s).${reason}`, { position: "top-right", timeout: 10000 });
                } else {
                    this.$dialog.notify.success(`${summary.sent || 0} notificação(ões) enviada(s) com sucesso!`, { position: "top-right", timeout: 4000 });
                }
                this.dialogNotify = false;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao enviar notificações.", { position: 'top-right', timeout: 3000 });
            } finally {
                this.notifyLoading = false;
            }
        },

        formatDate(date) {
            if (!date || date === "0000-00-00 00:00:00") return null;
            return this.$moment(date).format('YYYY-MM-DD');
        },

        formatDateBr(date) {
            if (!date || date === "0000-00-00 00:00:00" || date === "0000-00-00") return '-';
            return this.$moment(date).utc(false).format('DD/MM/YYYY');
        },

        toDateOrNull(value) {
            if (!value || String(value).startsWith('0000-00-00')) return null;
            const parsed = this.$moment(value).utc(false);
            return parsed.isValid() ? parsed : null;
        },
        updateLegalTerm(value) { this.dataset.data.legal_term = value; },
        updateJudgment(value) { this.dataset.data.judgment_at = value; },
        updateDeferment(value) { this.dataset.data.deferment_at = value; },
        updateStartEvent(value) { this.dataset.data.start_event_at = value; },
        updateEndEvent(value) { this.dataset.data.end_event_at = value; },
        updateLegalDeadline(value) { this.dataset.data.habdiv_legal_deadline_at = value; },
        updateInsolvency(value) { this.dataset.data.insolvency_at = value; },
        updateLiquidation(value) { this.dataset.data.liquidation_at = value; },

        formatCpfCnpj(value) {
            if(!value) return '';
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        goBack() {
            this.$router.replace("/casos");
        },

        openDoc(doc) {
            this.selectedDoc = doc;
            this.dialogViewDoc = true;
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.loadCreditors();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.loadCreditors();
        },

        setPageSize(size) {
            this.dataList.options.itemsPerPage = size;
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.loadDistricts()
            await this.loadEmployees()
            await this.load();
            await this.loadDocCategories();
            await this.loadCreditors();
            
            await this.loadRequestedDocs(); 
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? `Novo caso` : `Detalhes do caso`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: "Homepage", disabled: false, to: "/home", exact: true, },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de casos", disabled: false, to: "/casos", exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? `Incluir` : `Detalhes do caso`, disabled: true, exact: true,
            });
        },

        onChangeDocType() {
            if (!this.dataset.data.documents) {
                this.dataList.docsFilter = [];
                return;
            }

            const selectedCategory = this.dataset.docCategories.find((item) => item.id === this.dataset.selectedDocCategory);

            if (!selectedCategory) {
                this.dataList.docsFilter = this.dataset.data.documents.slice().sort((a, b) => a.order - b.order);
                return;
            }

            this.dataList.docsFilter = this.dataset.data.documents
                .filter((item) => item.client_doc_category_id === selectedCategory.id || (!item.client_doc_category_id && item.type === selectedCategory.type))
                .sort((a, b) => a.order - b.order);
            this.buildDocGroups();
        },

        // Mesmo agrupamento do site: topo da aba primeiro, depois as subcategorias
        // na ordem do primeiro documento de cada uma.
        buildDocGroups() {
            const groups = [{ key: 'top', name: null, docs: [] }];
            this.dataList.docsFilter.forEach((doc) => {
                const name = doc.section || null;
                let group = groups.find((item) => item.name === name);
                if (!group) {
                    group = { key: `section-${name}`, name, docs: [] };
                    groups.push(group);
                }
                group.docs.push(doc);
            });
            this.docGroups = groups;
        },

        docNumber(groupIndex, index) {
            return this.visibleDocGroups.slice(0, groupIndex).reduce((total, group) => total + group.docs.length, 0) + index + 1;
        },

        openSectionDialog(group = null) {
            this.sectionDialog = { show: true, name: group ? group.name : '', group, loading: false };
        },

        async saveSectionDialog() {
            const name = (this.sectionDialog.name || '').trim();
            if (!name) return;

            const existing = this.docGroups.find((group) => group.name && group.name.toLowerCase() === name.toLowerCase());
            const group = this.sectionDialog.group;

            if (!group) {
                if (existing) {
                    this.$dialog.notify.warning("Já existe uma subcategoria com esse nome nesta categoria.", { position: 'top-right', timeout: 3000 });
                    return;
                }
                this.docGroups.push({ key: `section-${name}-${Date.now()}`, name, docs: [] });
                this.sectionDialog.show = false;
                return;
            }

            if (existing && existing !== group) {
                // Renomear para um nome que ja existe junta as duas subcategorias.
                existing.docs.push(...group.docs);
                this.docGroups.splice(this.docGroups.indexOf(group), 1);
            } else {
                group.name = name;
            }

            this.sectionDialog.loading = true;
            const saved = await this.saveDocumentOrder("Subcategoria salva com sucesso!");
            this.sectionDialog.loading = false;
            if (saved) this.sectionDialog.show = false;
        },

        async removeDocSection(group) {
            if (group.docs.length) {
                const proceed = await this.$dialog.confirm({
                    text: `Os ${group.docs.length} documento(s) de “${group.name}” não serão excluídos: vão para o topo da aba, sem subcategoria.`,
                    title: 'Remover subcategoria',
                    actions: { false: 'Cancelar', true: 'Remover' }
                });
                if (!proceed) return;
            }

            const top = this.docGroups.find((item) => !item.name);
            top.docs.push(...group.docs);
            this.docGroups.splice(this.docGroups.indexOf(group), 1);
            if (top.docs.length) await this.saveDocumentOrder("Subcategoria removida.");
        },

        async loadDocCategories() {
            if (this.page.isNew || !this.dataset.data.id) return;

            try {
                const result = await axios.get(`/api/admin/clients/${this.dataset.data.id}/client-doc-categories`);
                this.dataset.docCategories = this.sortDocCategories(this.ensureFixedDocCategories(result.data.content || []));

                if (!this.dataset.selectedDocCategory && this.dataset.docCategories.length > 0) {
                    this.dataset.selectedDocCategory = this.dataset.docCategories[0].id;
                }

                this.onChangeDocType();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao carregar categorias de documentos", { position: 'top-right', timeout: 3000 });
            }
        },

        async createDocCategory() {
            const name = (this.docCategoryForm.name || '').trim();

            if (!name || !this.dataset.data.id) {
                this.$dialog.notify.warning("Informe o nome da categoria.", { position: 'top-right', timeout: 3000 });
                return;
            }

            this.docCategoryForm.loading = true;

            try {
                const result = await axios.post(`/api/admin/clients/${this.dataset.data.id}/client-doc-categories`, { name });
                const category = result.data.content;
                this.docCategoryForm.name = '';
                await this.loadDocCategories();
                if (category && category.id) this.dataset.selectedDocCategory = category.id;
                this.onChangeDocType();
                this.$dialog.notify.info("Categoria criada com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao criar categoria", { position: 'top-right', timeout: 3000 });
            } finally {
                this.docCategoryForm.loading = false;
            }
        },

        sortDocCategories(categories) {
            return categories.slice().sort((a, b) => {
                const aIsOther = this.isOtherDocumentsCategory(a.name);
                const bIsOther = this.isOtherDocumentsCategory(b.name);

                if (aIsOther === bIsOther) return 0;
                return aIsOther ? 1 : -1;
            });
        },

        ensureFixedDocCategories(categories) {
            const normalizedCategories = categories.slice();
            const hasCreditVerificationReport = normalizedCategories.some((category) => {
                return category.type === 6 || this.isCreditVerificationReportCategory(category.name);
            });

            if (!hasCreditVerificationReport) {
                const fixedCategory = this.dataset.clientDocTypes.find((item) => item.id === 6);

                if (fixedCategory) {
                    normalizedCategories.push({
                        id: `legacy-${fixedCategory.id}`,
                        name: fixedCategory.name,
                        type: fixedCategory.id,
                        is_legacy: true,
                    });
                }
            }

            return normalizedCategories;
        },

        isCreditVerificationReportCategory(name) {
            const normalized = this.normalizeText(name);
            return normalized.includes('relatorio') &&
                normalized.includes('verificacao de creditos');
        },

        isSelectedDocCategoryPersisted() {
            const category = this.dataset.docCategories.find((item) => item.id === this.dataset.selectedDocCategory);
            return !!(category && !category.is_legacy);
        },

        isOtherDocumentsCategory(name) {
            const normalized = this.normalizeText(name);
            return normalized === 'outros' || normalized === 'outros documentos';
        },

        normalizeText(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },

        async deleteDocCategory() {
            const category = this.dataset.docCategories.find((item) => item.id === this.dataset.selectedDocCategory);
            if (!category) return;
            if (category.is_legacy) {
                this.$dialog.notify.warning("Categorias fixas não podem ser removidas.", { position: 'top-right', timeout: 3000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja remover a categoria "${category.name}"? Os documentos cadastrados não serão excluídos.`,
                title: 'Remover categoria',
                actions: { false: 'Cancelar', true: 'Remover' }
            });

            if (!proceedAction) return;

            this.docCategoryForm.deleting = true;

            try {
                await axios.delete(`/api/admin/client-doc-categories/${category.id}`);
                this.dataset.selectedDocCategory = null;
                await this.loadDocCategories();
                this.$dialog.notify.info("Categoria removida com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao remover categoria", { position: 'top-right', timeout: 3000 });
            } finally {
                this.docCategoryForm.deleting = false;
            }
        },

        action(e) {
            switch (e) {
                case 'edit':
                    this.before = this.docGroups.map((group) => ({ ...group, docs: group.docs.slice() }));
                    break;
                case 'undo':
                    this.docGroups = this.before;
                    break;
                case 'done':
                    this.saveDocumentOrder()
                    break;
                default:
                    break;
            }
            this.editing = !this.editing
        },

        // Grava ordem e subcategoria de cada documento conforme os grupos na tela.
        async saveDocumentOrder(message = "Nova ordenação salva com sucesso!") {
            const docs = [];
            this.docGroups.forEach((group) => group.docs.forEach((doc) => docs.push({ doc, section: group.name || null })));
            if (!docs.length) return true;

            const data = docs.map(({ doc, section }, index) => ({
                id: doc.id,
                client_id: doc.client_id,
                order: index + 1,
                section,
            }));

            try {
                await axios.patch(`/api/admin/client-docs/order/${data[0].client_id}`, { list: data });
                docs.forEach(({ doc, section }, index) => {
                    doc.order = index + 1;
                    doc.section = section;
                });
                // Subcategoria ainda sem documento continua na tela ate a pagina recarregar.
                const empty = this.docGroups.filter((group) => group.name && !group.docs.length);
                this.onChangeDocType();
                this.docGroups.push(...empty);
                this.$dialog.notify.info(message, { position: "top-right", timeout: 2000 });
                return true;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
                return false;
            }
        },

        openEditDocumentModal(item) {
            this.$refs.clientDocDetailsModalRef.setData({
                ...this.dataset.data,
                docCategories: this.dataset.docCategories,
                docSections: this.docSections(),
                selectedDocCategory: this.dataset.selectedDocCategory,
            }, item);
            this.$refs.clientDocDetailsModalRef.open().then(async (results) => {
                await this.load();
                await this.loadDocCategories();
                this.onChangeDocType();
            });
        },

        async deleteDocument(item) {
            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir documento',
                actions: { false: 'Cancelar', true: 'Excluir' }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {
                await axios.delete(`/api/admin/client-docs/${item.id}`)
                this.$dialog.notify.info("Documento excluído com sucesso!", { position: "top-right", timeout: 2000 });
                await this.load()
                this.onChangeDocType()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataList.loading = false;
            }
        },

        buildPayloadDocument() {
            const lastValue = this.items.reduce((max, obj) => (obj.order > max ? obj.order : max), -Infinity);
            return {
                order: isFinite(lastValue) ? lastValue + 1 : 1,
                client: this.dataset.data.client_id
            };
        },

        // Subcategorias de cada categoria (sugestoes no cadastro do documento),
        // incluindo as recem-criadas que ainda nao tem documento.
        docSections() {
            const map = {};
            const add = (categoryId, name) => {
                if (!categoryId || !name) return;
                map[categoryId] = map[categoryId] || [];
                if (!map[categoryId].includes(name)) map[categoryId].push(name);
            };
            (this.dataset.data.documents || []).forEach((doc) => add(doc.client_doc_category_id, doc.section));
            this.docGroups.forEach((group) => add(this.dataset.selectedDocCategory, group.name));
            return map;
        },

        async openAddDocumentModal(item, section = null) {
            this.$refs.clientDocDetailsModalRef.setData({
                ...item,
                docCategories: this.dataset.docCategories,
                docSections: this.docSections(),
                selectedDocCategory: this.dataset.selectedDocCategory,
                selectedSection: section,
            });
            this.$refs.clientDocDetailsModalRef.open().then(async (results) => {
                await this.load();
                await this.loadDocCategories();
                this.onChangeDocType();
            });
        },

        async loadEdital7() {
            if (this.page.isNew || !this.$route.params.id) return;
            try {
                const result = await axios.get(`/api/admin/clients/${this.$route.params.id}/qgc-versions`);
                const versions = (result.data.content && result.data.content.versions) || [];
                const edital7 = versions.find((item) => item.reference_type === 'edital_7');
                const date = edital7 && edital7.reference_date ? String(edital7.reference_date).slice(0, 10) : null;
                this.edital7 = { id: edital7 ? edital7.id : null, date, saved: date, saving: false };
            } catch (error) {
                this.edital7 = { id: null, date: null, saved: null, saving: false };
            }
        },

        async saveEdital7Date() {
            if (!this.edital7.id) return;
            this.edital7.saving = true;
            try {
                await axios.patch(`/api/admin/qgc-versions/${this.edital7.id}`, { reference_date: this.edital7.date || '' });
                this.edital7.saved = this.edital7.date || null;
                this.$dialog.notify.success('Data de publicação do Edital do art. 7º salva.', { position: 'top-right', timeout: 3000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao salvar a data de publicação', { position: 'top-right', timeout: 5000 });
            } finally {
                this.edital7.saving = false;
            }
        },

        async suggestRvcTexts() {
            if (this.page.isNew) return;
            const hasText = [this.rvcTexts.introduction, this.rvcTexts.preliminary_topics].some((html) => String(html || '').replace(/<[^>]+>|&nbsp;/g, '').trim());
            if (hasText) {
                const proceed = await this.$dialog.confirm({
                    text: 'Os textos atuais serão substituídos pela sugestão montada com os dados do caso. Continuar?',
                    title: 'Preencher automaticamente',
                    actions: { false: 'Cancelar', true: 'Substituir' }
                });
                if (!proceed) return;
            }
            this.rvcTexts.suggesting = true;
            try {
                const result = await axios.get(`/api/admin/clients/${this.dataset.data.id}/rvc-texts/suggestion`);
                this.rvcTexts.introduction = result.data.content.rvc_introduction || '';
                this.rvcTexts.preliminary_topics = result.data.content.rvc_preliminary_topics || '';
                this.$dialog.notify.info('Textos preenchidos. Revise e clique em "Salvar textos".', { position: 'top-right', timeout: 4000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao montar os textos', { position: 'top-right', timeout: 5000 });
            } finally {
                this.rvcTexts.suggesting = false;
            }
        },

        async saveRvcTexts() {
            if (this.page.isNew) return;
            this.rvcTexts.saving = true;
            try {
                const result = await axios.patch(`/api/admin/clients/${this.dataset.data.id}/rvc-texts`, {
                    rvc_introduction: this.rvcTexts.introduction || '',
                    rvc_preliminary_topics: this.rvcTexts.preliminary_topics || '',
                });
                this.dataset.data.rvc_introduction = result.data.content.rvc_introduction;
                this.dataset.data.rvc_preliminary_topics = result.data.content.rvc_preliminary_topics;
                this.$dialog.notify.success('Textos do RVC salvos.', { position: 'top-right', timeout: 3000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao salvar os textos', { position: 'top-right', timeout: 5000 });
            } finally {
                this.rvcTexts.saving = false;
            }
        },

        async load() {
            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/clients/${this.$route.params.id}`);
                const data = result.data.content;

                this.dataset.data = {
                    ...data,
                    show_qgc_on_site: Number(data.show_qgc_on_site) === 1,
                    rural_producer: Number(data.rural_producer) === 1,
                    consolidation_type: Number(data.consolidation_type) || null,
                    creditor_portal_enabled: Number(data.creditor_portal_enabled) !== 0,
                    portal_habdiv_enabled: Number(data.portal_habdiv_enabled) !== 0,
                    portal_procurators_enabled: Number(data.portal_procurators_enabled) !== 0,
                    portal_accreditations_enabled: Number(data.portal_accreditations_enabled) !== 0,
                    portal_bank_enabled: Number(data.portal_bank_enabled) !== 0,
                    // Datas vazias viram null. Um moment invalido e "truthy" e acabaria
                    // enviado como 'Invalid date' ao salvar.
                    judgment_at: this.toDateOrNull(data.judgment_at),
                    deferment_at: this.toDateOrNull(data.deferment_at),
                    start_event_at: this.toDateOrNull(data.start_event_at),
                    end_event_at: this.toDateOrNull(data.end_event_at),
                    habdiv_legal_deadline_at: this.toDateOrNull(data.habdiv_legal_deadline_at),
                    legal_term: this.toDateOrNull(data.legal_term),
                    insolvency_at: this.toDateOrNull(data.insolvency_at),
                    liquidation_at: this.toDateOrNull(data.liquidation_at),
                    companies: Array.isArray(data.companies) ? data.companies.map(company => ({
                        id: company.id || null,
                        name: company.name || '',
                        registration: company.registration || ''
                    })) : [],
                };
                this.rvcTexts.introduction = data.rvc_introduction || '';
                this.rvcTexts.preliminary_topics = data.rvc_preliminary_topics || '';
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        async loadCreditors() {
            if (this.page.isNew) return;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))
            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;
            var page = this.dataList.options.page;

            try {
                const result = await axios.get(`/api/admin/clients/creditors/${this.$route.params.id}`, { params: { page, limit, search } });
                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        async loadDistricts() {
            try {
                const result = await axios.get(`/api/districts`, { params: { start: 1, limit: 100000, search: {} } });
                this.dataset.districts = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        async loadEmployees() {
            try {
                const result = await axios.get(`/api/employees`, { params: { start: 1, limit: 100000, search: {} } });
                this.dataset.employees = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o caso?',
                title: 'Incluir caso',
                actions: { false: 'Cancelar', true: 'Salvar' }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;
            const payload = this.buildPayload();

            try {
                await axios.post('/api/admin/clients', payload);
                this.$dialog.notify.info("Caso salvo com sucesso", { position: "top-right", timeout: 2000 });
                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o caso?',
                title: 'Atualizar caso',
                actions: { false: 'Cancelar', true: 'Atualizar' }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;
            const payload = this.buildPayload();

            try {
                console.log(this.dataset.data.name)
                await axios.patch(`/api/admin/clients/${this.$route.params.id}`, payload);
                this.$dialog.notify.info("Cliente salvo com sucesso", { position: "top-right", timeout: 2000 });
                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },

        async deleteFile(file) {
            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir arquivo',
                actions: { false: 'Cancelar', true: 'Excluir' }
            })

            if (!proceedAction) return;

            try {
                await axios.delete(`/api/admin/clients/${this.$route.params.id}/file/${file}`)
                this.$dialog.notify.info("Arquivo excluído com sucesso", { position: "top-right", timeout: 2000 });
                this.load()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        verifyPendingEvents() {
            if (!this.dataset.data || !this.dataset.data.events) return false;
            return this.dataset.data.events.every((x) => x.status != 0);
        },

        onFileSelected(field, file) {
            this.dataset.data[field] = file;
        },

        async generateFinalReport() {
            this.rvcGenerating = true;
            try {
                const result = await axios.post('/api/admin/user-events/final-report-pdf', { client_id: this.dataset.data.id });
                const file = result.data.content;

                this.downloadBase64File(file.base64, file.fileName || 'rvc.pdf', file.mimeType || 'application/pdf');
                this.$dialog.notify.info("RVC gerado com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.rvcGenerating = false;
            }
        },

        downloadBase64File(base64, fileName, mimeType) {
            const byteCharacters = atob(base64);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);
                const byteNumbers = new Array(slice.length);

                for (let i = 0; i < slice.length; i += 1) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                byteArrays.push(new Uint8Array(byteNumbers));
            }

            const blob = new Blob(byteArrays, { type: mimeType });
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);

            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
        },

        async generateNoticeReportPdf() {
            this.dataset.loading = true;
            try {
                const result = await axios.get(`/api/admin/user-events/notice-report-pdf/${this.dataset.data.id}`, { responseType: 'arraybuffer' });
                let blob = new Blob([result.data], { type: 'application/pdf' });
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Edital.pdf'
                link.click()
                this.$dialog.notify.info("Pdf edital gerado com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },

        async generateNoticeReportDocx() {
            this.dataset.loading = true;
            try {
                const result = await axios.get(`/api/admin/user-events/notice-report-docx/${this.dataset.data.id}`, { responseType: 'arraybuffer' });
                let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Edital.docx'
                link.click()
                this.$dialog.notify.info("Documemnto edital gerado com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },

        async generateLetterAnalysisReportPdf() {
            this.dataset.loading = true;
            try {
                await axios.post('/api/admin/user-events/letter-analysis-report-pdf', { client_id: this.dataset.data.id });
                this.$dialog.notify.info("Pdf da Análise de Ofício gerado com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },

        // ─── Timeline ─────────────────────
        async loadCreditorClasses() {
            if (!this.dataset.data.id) return;

            this.creditorClasses.loading = true;

            try {
                // include_inactive: a tela de configuracao mostra tambem as
                // classes ocultas, para permitir reexibi-las.
                const result = await axios.get(`/api/admin/clients/${this.dataset.data.id}/creditor-classes`, {
                    params: { include_inactive: true }
                });

                this.creditorClasses.data = (result.data.content && result.data.content.data) || [];
            } catch (error) {
                this.creditorClasses.data = [];
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao carregar as classes do caso', { position: 'top-right', timeout: 3000 });
            } finally {
                this.creditorClasses.loading = false;
            }
        },

        getCreditorClassBaseName(item) {
            const base = this.dataset.creditorTypes.find((type) => Number(type.id) === Number(item.base_class_id));
            return base ? `Como ${base.name}` : 'Personalizada';
        },

        openCreditorClassForm(item = null) {
            this.creditorClasses.form = {
                visible: true,
                loading: false,
                id: item ? item.id : null,
                name: item ? item.name : '',
                base_class_id: item ? item.base_class_id : null,
            };
        },

        closeCreditorClassForm() {
            this.creditorClasses.form = {
                visible: false,
                loading: false,
                id: null,
                name: '',
                base_class_id: null,
            };
        },

        async saveCreditorClass() {
            const form = this.creditorClasses.form;

            if (form.loading) return;

            const name = (form.name || '').trim();

            if (!name) {
                this.$dialog.notify.error('Informe o nome da classe', { position: 'top-right', timeout: 3000 });
                return;
            }

            if (!form.id && !form.base_class_id) {
                this.$dialog.notify.error('Selecione a classe base', { position: 'top-right', timeout: 3000 });
                return;
            }

            form.loading = true;

            try {
                if (form.id) {
                    await axios.patch(`/api/admin/creditor-classes/${form.id}`, { name });
                } else {
                    await axios.post(`/api/admin/clients/${this.dataset.data.id}/creditor-classes`, {
                        name,
                        base_class_id: form.base_class_id,
                    });
                }

                this.$dialog.notify.success(form.id ? 'Classe atualizada' : 'Classe adicionada', { position: 'top-right', timeout: 3000 });
                this.closeCreditorClassForm();
                creditorClassUtil.invalidate(this.dataset.data.id);
                await this.loadCreditorClasses();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao salvar a classe', { position: 'top-right', timeout: 3000 });
                form.loading = false;
            }
        },

        async confirmCreditorClassDeactivation(item) {
            this.creditorClasses.deactivation = {
                dialog: true,
                loading: false,
                item,
                creditorsCount: 0,
            };

            try {
                const result = await axios.get(`/api/admin/creditor-classes/${item.id}/usage`);
                this.creditorClasses.deactivation.creditorsCount = (result.data.content && result.data.content.creditors_count) || 0;
            } catch (error) {
                this.creditorClasses.deactivation.creditorsCount = 0;
            }
        },

        async deactivateCreditorClass() {
            const deactivation = this.creditorClasses.deactivation;

            if (!deactivation.item || !deactivation.item.id) return;

            deactivation.loading = true;

            try {
                await axios.delete(`/api/admin/creditor-classes/${deactivation.item.id}`);

                this.$dialog.notify.success('Classe ocultada', { position: 'top-right', timeout: 3000 });
                deactivation.dialog = false;
                creditorClassUtil.invalidate(this.dataset.data.id);
                await this.loadCreditorClasses();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao ocultar a classe', { position: 'top-right', timeout: 3000 });
            } finally {
                deactivation.loading = false;
            }
        },

        async activateCreditorClass(item) {
            try {
                await axios.post(`/api/admin/creditor-classes/${item.id}/activate`);

                this.$dialog.notify.success('Classe reexibida', { position: 'top-right', timeout: 3000 });
                creditorClassUtil.invalidate(this.dataset.data.id);
                await this.loadCreditorClasses();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao reexibir a classe', { position: 'top-right', timeout: 3000 });
            }
        },

        async loadTimeline() {
            if (!this.dataset.data.id) return;
            this.timeline.loading = true;
            try {
                const { data } = await axios.get(`/api/clients/${this.dataset.data.id}/events`);
                this.timeline.events = data.content || [];
            } catch (error) {
                this.timeline.events = [];
            } finally {
                this.timeline.loading = false;
            }
        },

        async loadNews() {
            if (!this.dataset.data.id) return;
            this.news.loading = true;
            try {
                const result = await axios.get(`/api/admin/clients/${this.dataset.data.id}/news`);
                this.news.items = result.data.content || [];
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.news.loading = false;
            }
        },

        openNewsDialog(item = null) {
            this.news.editing = item;
            this.news.imageFile = null;
            this.news.removeImage = false;
            this.news.form = item
                ? { title: item.title, published_at: item.published_at || '', content: item.content || '' }
                : { title: '', published_at: this.$moment().format('YYYY-MM-DD'), content: '' };
            this.news.dialog = true;
        },

        async saveNews() {
            if (!String(this.news.form.title || '').trim()) {
                this.$dialog.notify.warning('Informe o título da notícia', { position: 'top-right', timeout: 2000 });
                return;
            }
            if (!this.news.form.published_at) {
                this.$dialog.notify.warning('Informe a data da notícia', { position: 'top-right', timeout: 2000 });
                return;
            }
            this.news.saving = true;
            try {
                // Multipart por causa da imagem.
                const formData = new FormData();
                formData.append('title', this.news.form.title);
                formData.append('published_at', this.news.form.published_at);
                formData.append('content', this.news.form.content || '');
                if (this.news.imageFile) formData.append('image', this.news.imageFile);
                if (this.news.removeImage) formData.append('remove_image', '1');

                if (this.news.editing) {
                    await axios.patch(`/api/admin/client-news/${this.news.editing.id}`, formData);
                    this.$dialog.notify.info('Notícia atualizada', { position: 'top-right', timeout: 2000 });
                } else {
                    await axios.post(`/api/admin/clients/${this.dataset.data.id}/news`, formData);
                    this.$dialog.notify.info('Notícia publicada', { position: 'top-right', timeout: 2000 });
                }
                this.news.dialog = false;
                this.loadNews();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.news.saving = false;
            }
        },

        async deleteNews(item) {
            const confirm = await this.$dialog.confirm({
                text: `Deseja excluir a notícia "${item.title}"?`,
                title: 'Excluir notícia',
                actions: { false: 'Cancelar', true: 'Excluir' }
            });
            if (!confirm) return;
            try {
                await axios.delete(`/api/admin/client-news/${item.id}`);
                this.$dialog.notify.info('Notícia excluída', { position: 'top-right', timeout: 2000 });
                this.loadNews();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            }
        },

        openEventDialog(event = null) {
            if (event) {
                this.timeline.editing = event;
                this.timeline.form = {
                    title: event.title,
                    article_ref: event.article_ref || '',
                    date: event.date ? this.$moment(event.date).format('YYYY-MM-DD') : '',
                    description: event.description || '',
                };
            } else {
                this.timeline.editing = null;
                this.timeline.form = { title: '', article_ref: '', date: '', description: '' };
            }
            this.timeline.dialog = true;
        },

        async saveEvent() {
            if (!this.timeline.form.title) {
                this.$dialog.notify.warning('Informe o título do evento', { position: 'top-right', timeout: 2000 });
                return;
            }
            this.timeline.saving = true;
            try {
                const payload = {
                    title: this.timeline.form.title,
                    article_ref: this.timeline.form.article_ref || null,
                    date: this.timeline.form.date || null,
                    description: this.timeline.form.description || null,
                };

                if (this.timeline.editing) {
                    await axios.patch(`/api/admin/client-events/${this.timeline.editing.id}`, payload);
                    this.$dialog.notify.info('Evento atualizado', { position: 'top-right', timeout: 2000 });
                } else {
                    payload.order = this.timeline.events.length;
                    await axios.post(`/api/admin/clients/${this.dataset.data.id}/events`, payload);
                    this.$dialog.notify.info('Evento adicionado', { position: 'top-right', timeout: 2000 });
                }
                this.timeline.dialog = false;
                this.loadTimeline();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.timeline.saving = false;
            }
        },

        async deleteEvent(event) {
            const confirm = await this.$dialog.confirm({
                text: `Deseja excluir o evento "${event.title}"?`,
                title: 'Excluir evento',
                actions: { false: 'Cancelar', true: 'Excluir' }
            });
            if (!confirm) return;

            try {
                await axios.delete(`/api/admin/client-events/${event.id}`);
                this.$dialog.notify.info('Evento excluído', { position: 'top-right', timeout: 2000 });
                this.loadTimeline();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            }
        },

        addCompany() {
            if (!Array.isArray(this.dataset.data.companies)) {
                this.$set(this.dataset.data, 'companies', []);
            }

            this.dataset.data.companies.push({ id: null, name: '', registration: '' });
        },

        removeCompany(index) {
            if (!Array.isArray(this.dataset.data.companies)) return;
            this.dataset.data.companies.splice(index, 1);
        },

        buildPayload() {
            const formData = new FormData()
            const companies = Array.isArray(this.dataset.data.companies)
                ? this.dataset.data.companies
                    .map(company => ({
                        id: company.id || null,
                        name: company.name ? String(company.name).trim() : '',
                        registration: company.registration ? string.sanitizeCpfCnpj(company.registration) : null,
                    }))
                    .filter(company => company.name)
                : [];
            
            if (this.dataset.data.description) formData.append('description', this.dataset.data.description);
            if (this.dataset.data.name) formData.append('name', this.dataset.data.name);
            if (this.dataset.data.local) formData.append('local', this.dataset.data.local);
            if (this.dataset.data.email) formData.append('email', this.dataset.data.email);
            if (this.dataset.data.state) formData.append('state', this.dataset.data.state);
            if (this.dataset.data.process_number) formData.append('process_number', this.dataset.data.process_number);
            if (this.dataset.data.total_creditors) formData.append('total_creditors', this.dataset.data.total_creditors);
            if (this.dataset.data.total_value) formData.append('total_value', this.dataset.data.total_value);
            formData.append('show_qgc_on_site', this.dataset.data.show_qgc_on_site ? '1' : '0');
            formData.append('rural_producer', this.dataset.data.rural_producer ? '1' : '0');
            formData.append('consolidation_type', this.dataset.data.consolidation_type || '');
            this.portalFlags.forEach((flag) => formData.append(flag.key, this.dataset.data[flag.key] ? '1' : '0'));
            if (this.dataset.data.registration) formData.append('registration', this.dataset.data.registration);
            if (this.dataset.data.type) formData.append('type', this.dataset.data.type);
            
            if (this.dataset.data.legal_term) formData.append('legal_term', this.$moment(this.dataset.data.legal_term).format('YYYY-MM-DD'));
            // Desativado: os prazos de hab/div sao salvos pela Central de Creditos (aba "Cadastro da verificacao").
            // if (this.dataset.data.start_event_at) formData.append('start_event_at', this.$moment(this.dataset.data.start_event_at).format('YYYY-MM-DD'));
            // if (this.dataset.data.end_event_at) formData.append('end_event_at', this.$moment(this.dataset.data.end_event_at).format('YYYY-MM-DD'));
            // // Vazio limpa o prazo real; o interno segue a regra antiga.
            // formData.append('habdiv_legal_deadline_at', this.dataset.data.habdiv_legal_deadline_at ? this.$moment(this.dataset.data.habdiv_legal_deadline_at).format('YYYY-MM-DD') : '');
            if (this.dataset.data.judgment_at) formData.append('judgment_at', this.$moment(this.dataset.data.judgment_at).format('YYYY-MM-DD'));
            // Falencia nao envia deferimento, mesmo que o caso tenha o valor
            // gravado de antes da mudanca de tipo.
            if (this.showDefermentField && this.dataset.data.deferment_at) formData.append('deferment_at', this.$moment(this.dataset.data.deferment_at).format('YYYY-MM-DD'));
            if (this.dataset.data.insolvency_at) formData.append('insolvency_at', this.$moment(this.dataset.data.insolvency_at).format('YYYY-MM-DD'));
            if (this.dataset.data.liquidation_at) formData.append('liquidation_at', this.$moment(this.dataset.data.liquidation_at).format('YYYY-MM-DD'));
            
            if (this.dataset.data.district_id) formData.append('district_id', this.dataset.data.district_id);
            if (this.dataset.data.employee_id) formData.append('employee_id', this.dataset.data.employee_id);
            formData.append('accounting_employee_id', this.dataset.data.accounting_employee_id || '');
            
            if (this.dataset.data.fileLogo) formData.append('files[]', this.dataset.data.fileLogo, 'logo')
            if (this.dataset.data.fileBanner) formData.append('files[]', this.dataset.data.fileBanner, 'banner')
            formData.append('companies', JSON.stringify(companies))

            return formData;
        },

        getStatusLabel(status) {
            const map = {
                0: 'Pendente',
                1: 'Enviado',
                2: 'Justificado',
                3: 'Concluído'
            };
            return map[status] || 'Desconhecido';
        },

        getStatusColor(status) {
            const map = {
                0: 'warning',
                1: 'success',
                2: 'error',
                3: 'primary'
            };
            return map[status] || 'grey';
        },
    },
};
</script>

<style lang="scss">
.access-container { border: 1px solid var(--v-gray-base) !important; }
.custom-chip { background: var(--v-white-base) !important; }
.title-page { color: var(--v-primary-base); font-size: 40px; font-style: normal; font-weight: 700; line-height: 38px; }
.section-info-title { color: var(--v-primary-base); font-size: 16px; font-style: normal; font-weight: 700; }
.section-info-value { font-size: 14px; font-style: normal; }
.checkbox-container { display: flex; justify-content: space-between; width: 100%; }

.client-tabs-bar .client-tabs { flex: 1 1 auto; min-width: 0; width: auto; }

.bg-light-grey { background-color: #fafafa !important; }
.border-bottom { border-bottom: 1px solid #eeeeee; }

/* Documentos do caso agrupados por subcategoria. */
.doc-groups__hint { display: flex; align-items: center; padding: 10px 16px; background: #f5f3ff; color: #4c1d95; font-size: 13px; }
.doc-group + .doc-group { border-top: 1px solid #eeeef3; }
.doc-group__header { display: flex; align-items: center; padding: 10px 16px; background: #fafafc; border-bottom: 1px solid #eeeef3; }
.doc-group__title { font-weight: 600; font-size: 14px; color: #1d0533; }
.doc-group__count { margin-left: 10px; font-size: 12px; color: #6b6880; }
.doc-group__list { min-height: 8px; }
.doc-group__list--editing { min-height: 48px; }
.doc-group__list--editing:empty { margin: 10px 16px; border: 1px dashed #c4b5fd; border-radius: 6px; display: flex; align-items: center; justify-content: center; }
.doc-group__list--editing:empty::before { content: 'Arraste documentos para cá'; font-size: 13px; color: #6b6880; font-style: italic; }
.doc-group__list--editing .v-list-item { cursor: grab; }
.doc-group__empty { padding: 12px 16px 14px; font-size: 13px; color: #6b6880; font-style: italic; }
.read-only-editor .ProseMirror { 
    background-color: #f5f5f5; 
    border-radius: 4px;
    padding: 10px;
    color: #666;
}
.read-only-editor .tiptap-vuetify-editor__toolbar { display: none !important; }

/* Timeline horizontal */
.timeline-horizontal {
    position: relative;
    padding: 60px 20px;
    overflow-x: auto;
}

.timeline-line {
    position: absolute;
    top: 50%;
    left: 20px;
    right: 20px;
    height: 3px;
    background: #E0E0E8;
    transform: translateY(-50%);
}

.timeline-items {
    display: flex;
    gap: 8px;
    position: relative;
    min-width: max-content;
}

.timeline-item-h {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 120px;
    position: relative;
}

.timeline-marker {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 3px solid #FFFFFF;
    box-shadow: 0 0 0 2px #E0E0E8;
    z-index: 1;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.timeline-marker--done {
    background: #3D2E5C;
    box-shadow: 0 0 0 2px #3D2E5C;
}

.timeline-marker--pending {
    background: #E0E0E8;
}

.timeline-card {
    background: #FFFFFF;
    border: 1px solid #EEEEF3;
    border-radius: 6px;
    padding: 8px 10px;
    text-align: center;
    font-size: 11px;
    max-width: 130px;
}

.timeline-item-h--top .timeline-card {
    margin-bottom: 24px;
}

.timeline-item-h--bottom .timeline-card {
    margin-top: 24px;
}

.timeline-card-title {
    font-weight: 600;
    color: #1E1E2D;
    font-size: 11px;
    line-height: 1.3;
    margin-bottom: 2px;
}

.timeline-card-ref {
    color: #8E8EA1;
    font-size: 10px;
}

.timeline-card-date {
    color: #3D2E5C;
    font-weight: 700;
    font-size: 11px;
    margin-top: 4px;
}

.timeline-card-actions {
    margin-top: 4px;
    display: flex;
    justify-content: center;
    gap: 2px;
}

.qgc-preview-title {
    gap: 16px;
}

.qgc-preview-summary {
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    padding: 14px 16px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.qgc-preview-summary span {
    color: #6B7280;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: uppercase;
}

.qgc-preview-summary strong {
    color: #1F2937;
    font-size: 24px;
    line-height: 1.2;
}

.qgc-preview-summary.attorney {
    border-color: #F59E0B;
}

.qgc-preview-summary.user-event {
    border-color: #10B981;
}

.qgc-preview-summary.official-letter {
    border-color: #7C3AED;
}

.qgc-preview-source {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 180px;
}

.qgc-preview-source > span {
    color: #4B5563;
    font-size: 12px;
    line-height: 1.35;
}
</style>
